/*
  HANNE BLOCH slide-up and quick view (HB 2026-10-13, round 41, fix 5.88; the spec
  03_Operations/Shopify/Theme_Merge/261013_HB_theme_spec_collection_slideups_v1.md, Vic's answers of 13 Oct).

  The sheet (snippets/hb-sheet, one <dialog class="hb-sl"> per collection page): opens as a bottom sheet up to the top
  bar's lower edge on a phone (the cart's cap, read live) and as a centered window on desktop; closes on the x, the
  dim, Esc, a swipe down on its head and the phone's Back button (one history entry per open, consumed on close);
  locks the page behind it; traps focus (a native dialog) and returns it to the card. One sheet at a time, never over
  the cart, a quick add or its note, the gift note or the gift's own slide-up (blocked()).

  The quick view ("Mini PDP", Vic): the first tap on a card in the grid opens it instead of the product page: the
  pictures zoomed in (a rail, the next one peeking, thumbnails), the name and price, the color dots (the card's
  siblings), the sizes (M first, else the nearest in stock, her remembered size when in stock), ADD TO CART · price and
  "Take me to the product". Size guide shows the product page's Fit content inside the sheet, with a Back. An add
  closes the sheet; the quick add's own note rises ("Added to your cart", VIEW CART) and she keeps browsing. The "+"
  on the card is untouched (still the quick add). Never for B2B (the snippet renders nothing for them).

  Content comes from sections/hb-qv.liquid through the Section Rendering API (/products/<handle>?section_id=hb-qv),
  so the price follows her market and the sizes follow the quick add's rules. The Fit content comes from
  sections/hb-qv-fit.liquid (the product page's details snippet in an inert template), the fit panel lifted out of it.

  The Silk Tulle Set builder (HB 2026-10-13, round 42, fix 5.89; Vic's pick "Set Builder D"): "Build my set" on the band
  in the grid (snippets/hb-set-band) opens the same sheet with sections/hb-set (/?section_id=hb-set): a step strip
  (Color, Length, Scarf, Mini bag; the finished ones carry her choice and open again on tap), the stage with the
  pieces she has chosen, one step at a time, then the set with its total. CONTINUE TO CHECKOUT adds the skirt and the
  top (and the scarf while its step is on), reserves her mini bag exactly as RESERVE MY GIFT does (cart attribute
  hb_gift_reserved; assets/hb-tgift.js puts the bag in at the amount) and goes to the checkout; "Add to cart and keep
  browsing" adds the same and closes, the quick add's note rising. ?hb_set=open on a collection page opens it on load.

  The silk story reel (HB 2026-10-13, round 43, fix 5.90; Vic's pick "option 2 ... copy the feel of Instagram"): the
  story tile in the grid (snippets/hb-story-tile) or "The silk behind it" on the set band opens sections/hb-story
  (/?section_id=hb-story) in the same sheet: four moments and the set card, one card at a time with the next peeking,
  progress segments, a timer per card (Theme settings; it stops on the last card), a tap on the right turns the page,
  on the left turns back, a swipe does the same, a hold pauses; "1 of 5" and the set chip under the reel; BUILD MY SET
  swaps the reel for the set builder in the same sheet. ?hb_story=open opens it on load.

  HB 2026-10-14 (Vic's notes of 14 Oct, round 44): the page is held the theme's way while the sheet is open (the body
  fixed at its scroll position, as assets/dialog.js does for the drawer; overflow hidden on <html> made iOS jump), the
  rise starts on the next frame; the head floats over the content (no row of its own); the quick view fits the sheet
  without scrolling and shows at most eight colour dots (+n to the product); the builder is picture-first (the stage
  takes the height, the length as pills with the height note, the summary with the savings, the scarf added as it is);
  the reel ends right-aligned with the card before peeking, taps pass through to BUILD MY SET; the band is one tap.

  HB 2026-10-14 (Vic's notes of 14 Oct, round 45): the sheet covers the whole phone screen (no room left for the top
  bar) and its rise no longer runs inside a scrolled dialog (showModal's focus made iOS scroll the dialog's box; the box
  cannot scroll now, overflow: clip, and is set back to 0); the rail loops (a copy of the first picture after the last,
  the script jumps back once the rail rests on it); "Size guide & info" shows the product page's four tabs; the builder
  says "Your Silk Tulle Set, with 2 gifts from us", strikes the gifts' own prices on their steps, tells her scarf pick
  from her set's colour and drops "Step x of X"; the reel owns its touches so a hold pauses it on the phone.

  HB 2026-10-14 (round 47, fix 5.94, Vic's picks B6 and C1 of the round 46 mockups): the builder is image-first. It opens
  on a first page (SET.intro): the look of the first colour over the whole sheet, "Your Silk Tulle Set", "With 2 gifts
  from us.", what is in the set and the total, the white pill "Build my set" and "What is in the set" (the receipt, in
  place); no steps row. The pill goes to the colour step; Back from the colour step comes back here. Every step and the
  set lie over the look of her colour (a new colour crossfades in 250 ms; the other looks load after the first paint),
  the intro and the strip at the top, the step with the white pill and the price at the foot; the set keeps its ink bar.
  The foot stays inside the builder (nothing white under the picture). BUILD MY SET in the reel opens on the colour step
  (the reel's last card is that first page already).

  HB 2026-10-14 (round 48, fix 5.95, Vic's notes on round 47 and his Option 2): the receipt hides the light line it
  repeats; GIFT is a small outlined tag; Short before Regular, the height note in three lines ("The Top is One Size,
  fits XS-XL."); the scarf and the mini bag shown as picture tiles of the pieces themselves, their struck price with
  Complimentary under it, the bags named by color; the set's checkout is the same white pill the width of the screen
  with the total (no struck price); Forest Green and Pink join (Theme settings). Option 2, side by side for Vic to
  compare (?hb_set_v=2): the summary's lines fold open one at a time on one page (see paintLines).

  HB 2026-10-15 (QV round 1, fix 5.150, Vic: "Yes, move it first"): the quick view moved to its own files,
  assets/hb-qv.js and assets/hb-qv.css, loaded after this file while the quick view is on. This file keeps the sheet
  itself for all three (open, close, setHead, the head's drag, the page lock, the history entry, blocked), the set
  builder and the reel; window.HBSheet also hands out setHead and SHEET_MS for the quick view, which adds
  openQuickView to it. The paragraphs above that describe the quick view are its history; its code and its own
  notes are in assets/hb-qv.js now. Please leave the quick view's code out of this file.

  HB 2026-10-16 (round 71, Vic: "I do want you to start work on making the Builder one repeatable element that we can also
  use for" the Bandeau Silk Swimsuit with the Bandeau Top at 50% and the mini bag, the Glitter V-Swimsuit with the
  Adjustable Top at 50% and the mini bag, and the Knit Triangle Bikini with the Knit Belted Top and two complimentary
  pins): the builder is one engine for any set. sections/hb-set lists every set that is on as JSON of one shape
  (snippets/hb-set-json); the band carries its set's key (data-hb-set-key) and the builder opens on it; the lines a set
  has follow its definition (the colour, the length or the sizes, a second piece, the reduced top, the scarf, the bag,
  the pins). The Silk Tulle Set is one set of the list and keeps every decision of rounds 42 to 70. Option 1 (the
  steps) is gone; Option 3 (the dark) stays for the comparison Vic has not yet made.

  HB 2026-10-23 (round 92, Vic: "On Mobile: Silk Tulle Builder, add "Back" button in top left. Also make "WHAT IS IN THE
  SET" -> "WHAT'S IN ..."): on the phone the head's Back is back on every page of the builder (round 63 had taken it
  away), the white pill at the top left on the x's line: from the first page it closes the builder, from the colour line
  it goes to the first page, from a later line to the line before, from the last page to the last line. The words
  (YOUR SILK TULLE SET and the gifts) go back under the Back and the x, as before round 63. Desktop unchanged. The first
  page's link reads "What's in the set".

  HB 2026-10-25 (round 93, Vic, on the live site): "all swatch images should preload when possible. I.e. silk set colors
  as first priority, then silk set colors with scarf, then scarf product images and then mini bag. I just had slow load
  on scarf product images": one queue in that order (preloadLooks, warmLater), two pictures on their way at a time, from
  600 ms after the builder opens. "When go back from checkout that was reached directly from Builder, she should land on
  open cart with signature styles collection behind it (not go back to the builder with the pending greyed out ONE
  MOMENT pill)": on its way to the checkout the builder's page entry becomes Signature Styles with the cart open
  (CHECKOUT_BACK_URL, history.replaceState), and a page the browser brings back from its cache in that state goes there
  itself (pageshow). The Back pill is quieter (assets/hb-sheet.css).
*/
import { CartUpdateEvent } from '@theme/events';

const VERSION = '2026-11-02-r93-six'; // the band's six colours open the builder on theirs (2 Nov); r93 plus openSet's opts (the looks of Resort Launch, carried 2 Nov)
const SHEET_MS = 350;
const DESKTOP = 750;

const S = {
  open: false,
  mode: '',
  handle: '',
  url: '',
  card: null,
  opener: null,
  hist: false,
  closing: 0,
  fit: null, // the fit pane's HTML once fetched, per handle
  leaveFit: null, // the Fit pane's Back handler while the pane is up
  req: 0,
  navTo: '', // the product page to go to once the sheet's history entry is gone
  setHtml: '', // sections/hb-set once fetched (one per page)
  storyHtml: '', // sections/hb-story once fetched (one per page)
  wantV: 0, // the builder's option the tapped band asks for (round 49: the Option 2 band on all-apparel), else 0
  wantKey: '', // round 71: the set the tapped band asks for (data-hb-set-key), else the Silk Tulle Set
  grow: null, // round 63: the band's picture the builder grows out of (its frame on the screen, its source), while it opens
  growing: false,
};

// The story reel's own state
const STORY = {
  el: null,
  i: 0,
  n: 0,
  ms: 5000,
  timer: 0,
  startedAt: 0,
  left: 0,
  held: false,
  holdTimer: 0,
  swallow: false, // a hold or a swipe just ended: the click that follows is not a tap
  down: null,
};

// The set builder's own state (one set at a time)
const SET = {
  data: null, // the set she is building (round 71: one of the section's sets, the shop's money and shipping facts on it)
  el: null,
  foot: null,
  color: 0,
  mk: '', // the main piece's variant key: the skirt's length ("Regular"), the swimsuit's size ("M"), the bikini's "M/S"
  second: 0, // the second piece with a line of its own (the Knit Belted Top)
  addon: 0, // the top at the reduced price
  ak: '', // its size
  scarf: 0,
  bag: 0,
  pins: [], // the pins she picked, by index, a pin twice when she wants two of it
  busy: false,
  intro: true, // the first page (round 47): before the colour line
  receipt: false, // "What is in the set" open on the first page
  bg: '', // the look behind the builder now
  clip: '', // round 74: the top's clip playing behind the addon line, else ''
  bgi: -1, // which of the two picture layers shows it
  bgTok: 0,
  dark: false, // round 68: Option 3, the same builder in the dark
  ac: 'color', // the open line ('color', 'length', 'size', 'second', 'addon', 'scarf', 'bag', 'pins'; round 51), '' once all are chosen
  acDone: {}, // the lines she has chosen
  busyKind: '', // round 55: 'checkout' or 'keep', so only the button she tapped says One moment
  acRest: '', // round 58: the line a tap outside folded (no line open, the next not yet open)
  slide: 0, // round 58: the side a new colour's picture comes in from (1 from the right, -1 from the left)
  endLook: '4', // round 58, Vic's mockups of the last page's answer to a swipe up: '1' to '5' (?hb_set_end=); round 60: Ring
  scarfSeen: false, // round 63: her scarf has come into her set (its line reached once): the pictures show it from then on
  introSrc: '', // round 63: the first page's picture, the band's own
  lenOpen: false, // round 64: Short and Regular open in the colour line's Length row
  lenShown: false, // (as drawn, so the row folds rather than jumps)
  seenEnd: false, // round 84: the last page has shown once (desktop: the keep link stays from then on)
};

const dlg = () => document.querySelector('dialog.hb-sl');
const q = (sel, root) => (root || dlg()).querySelector(sel);
const phone = () => window.innerWidth < DESKTOP;

function blocked() {
  return !!(
    document.querySelector('cart-drawer-component dialog[open]') ||
    document.querySelector('dialog.hb-tg-dlg[open]') ||
    document.querySelector('.variant-popup.active, #freeGiftToast.is-visible, .hb-toast.is-in, .hb-tg-note.is-in') ||
    document.documentElement.classList.contains('hb-qa-busy')
  );
}

function setHead(opts) {
  const d = dlg();
  const back = q('[data-hb-sl-back]', d);
  const title = q('[data-hb-sl-title]', d);
  back.hidden = !opts.back;
  q('[data-hb-sl-back-tx]', d).textContent = opts.back || 'Back';
  title.textContent = opts.title || '';
}

function open(mode, opener) {
  const d = dlg();
  if (!d || S.open) return false;
  S.open = true;
  S.mode = mode;
  S.opener = opener || null;
  S.closing = 0;
  d.classList.remove('is-qv', 'is-set', 'is-story', 'is-grow', 'is-growing', 'is-dark');
  d.classList.add('is-' + (mode === 'product' ? 'qv' : mode));
  if (mode === 'set' && setWant() === 3) d.classList.add('is-dark'); // round 68: Option 3
  // round 63: the builder grows out of the band's picture (growFrom): the panel's clip starts on the picture's frame
  S.growing = false;
  if (mode === 'set' && S.grow) {
    d.classList.add('is-grow', 'is-growing');
    S.growing = true;
  }
  // The page is held the way the theme's drawer holds it (the body fixed at its scroll position): overflow hidden on
  // <html> made iOS jump the page and the sheet with it (Vic, 14 Oct). Round 75 let the hold wait for the grow's first
  // frame; round 76 (Vic's iPhone: an empty band under the sheet, the sheet stopping at the browser's bar): the hold
  // comes first again, since iOS sizes the sheet by the page's state as it opens.
  lockPage();
  // round 76 (Vic's iPhone: a white line under the sheet): while the set builder is open the page's canvas is the floor's
  // grey, so any strip a browser leaves under the sheet (its own bar, the safe area) is grey, never white
  if (mode === 'set') {
    document.documentElement.style.backgroundColor = 'rgb(238 238 238)';
    document.body.style.backgroundColor = 'rgb(238 238 238)';
  }
  try {
    d.showModal();
  } catch (e) {
    d.setAttribute('open', '');
  }
  // HB 2026-10-14 (round 45, Vic: the sheet "flows all the way from bottom and out of screen at top, then almost
  // instantly appears in final position"): showModal() focuses the first button in the sheet and iOS scrolls the
  // dialog's own box to show it while the panel still waits below the screen, so the rise ran inside a scrolled box
  // and snapped when the overflow was gone. The dialog cannot scroll any more (overflow: clip) and is set back to 0 here.
  d.scrollTop = 0;
  d.scrollLeft = 0;
  document.documentElement.classList.add('hb-sl-lock');
  // The phone's Back closes the sheet rather than leaving the page: one entry, consumed on close.
  try {
    history.pushState({ hbSheet: 1 }, '', location.href);
    S.hist = true;
  } catch (e) {
    S.hist = false;
  }
  // The rise starts on the next frame, from the closed place, so no frame of it is skipped
  void d.offsetWidth;
  requestAnimationFrame(() => {
    if (!S.open) return;
    d.scrollTop = 0;
    d.classList.add('is-open');
    if (S.growing) growRun();
  });
  // The panel takes the focus (not the x, which would wear the theme's focus ring); keyboard users still tab to it
  const panel = q('[data-hb-sl-panel]', d);
  if (panel) {
    panel.setAttribute('tabindex', '-1');
    try {
      panel.focus({ preventScroll: true });
    } catch (e) {
      /* nothing */
    }
  }
  track('hb_sheet_open', { mode });
  return true;
}

let pageY = 0;
let pageHeld = false;
function lockPage() {
  if (document.body.style.position === 'fixed') return; // the drawer or the gift holds it already
  pageY = window.scrollY || 0;
  document.body.style.width = '100%';
  document.body.style.position = 'fixed';
  document.body.style.top = '-' + pageY + 'px';
  pageHeld = true;
}
function unlockPage() {
  if (!pageHeld) return;
  pageHeld = false;
  document.body.style.width = '';
  document.body.style.position = '';
  document.body.style.top = '';
  window.scrollTo({ top: pageY, behavior: 'instant' });
}

function close(fromHistory) {
  const d = dlg();
  if (!d || !S.open) return;
  S.open = false;
  S.req += 1;
  // round 63: the sheet that grew out of the band leaves as the others do (down); the last page's rest ends
  d.classList.remove('is-grow', 'is-growing');
  S.grow = null;
  S.growing = false;
  calmReset();
  d.classList.remove('is-open');
  document.documentElement.style.backgroundColor = '';
  document.body.style.backgroundColor = '';
  if (S.hist && !fromHistory) {
    S.hist = false;
    try {
      history.back();
    } catch (e) {
      /* the entry stays; harmless */
    }
  }
  S.hist = false;
  clearTimeout(S.closing);
  S.closing = setTimeout(() => {
    if (d.open) d.close();
    document.documentElement.classList.remove('hb-sl-lock');
    unlockPage();
    d.classList.remove('is-qv', 'is-set', 'is-dark');
    q('[data-hb-sl-body]', d).innerHTML = '';
    const foot = q('[data-hb-sl-foot]', d);
    foot.innerHTML = '';
    foot.hidden = false;
    if (S.leaveFit) {
      // the Fit pane was up (or the set builder's Back): its Back listener goes with it
      q('[data-hb-sl-back]', d).removeEventListener('click', S.leaveFit);
      S.leaveFit = null;
    }
    SET.el = null;
    SET.foot = null;
    SET.busy = false;
    stopStory();
    d.classList.remove('is-story');
    setHead({});
    const back = S.opener;
    S.opener = null;
    S.card = null;
    if (back && typeof back.focus === 'function' && document.contains(back)) {
      try {
        back.focus({ preventScroll: true });
      } catch (e) {
        /* nothing */
      }
    }
  }, SHEET_MS);
}

function track(name, data) {
  try {
    if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') {
      window.Shopify.analytics.publish(name, data || {});
    }
  } catch (e) {
    /* analytics never breaks the sheet */
  }
  try {
    if (typeof window.clarity === 'function') window.clarity('event', name);
  } catch (e) {
    /* nothing */
  }
}

// ---------------------------------------------------------------------------------------------------------------
// esc(), used by the set builder and the reel. (The quick view that sat here lives in assets/hb-qv.js since QV
// round 1, HB 2026-10-15, fix 5.150.)

function esc(s) {
  return String(s == null ? '' : s).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
}

// ---------------------------------------------------------------------------------------------------------------
// The set builder (sections/hb-set, snippets/hb-set-json): the pieces as JSON, the lines drawn here
//
// HB 2026-10-16 (round 71, Vic: "making the Builder one repeatable element that we can also use for" the Bandeau Silk
// Swimsuit with the Bandeau Top at 50% and the mini bag, the Glitter V-Swimsuit with the Adjustable Top at 50% and the
// mini bag, and the Knit Triangle Bikini with the Knit Belted Top and two complimentary pins): one builder for any set.
// The section lists every set that is on, the same shape for all (key, kind, cap, pieces, colours with the main
// piece's variants on its axes, a second piece, the reduced tops, the scarves, the bags, the pins); the band carries
// its set's key (data-hb-set-key) and the builder opens on that set. The lines a set has, in order: the colour, the
// main piece's own choice (the skirt's length, the swimsuit's size, the bikini's top and bottom sizes), the second
// piece when it has a line of its own (the Knit Belted Top; the Silk Tulle Top follows the colour and has none), the
// top at a reduced price, the scarf, the mini bag, the pins (pick two). Everything the Silk Tulle Set did (rounds 42 to
// 70) it still does, the same way: its data is one set of the list. Option 1 (the steps, ?hb_set_v=1) is gone with
// this round, as Vic chose Option 2 in round 68 ("this is our choice, focus on this only now"); Option 3 (the dark,
// ?hb_set_v=3 or the second band) stays for his comparison.

// Round 56 (Vic: "Make sure for product names to always follow our site's naming conventions, i.e. "Silk Tulle Skirt"
// "Mini Bag""): the pieces by their titles on the site ("White Silk Tulle Skirt and Top", "White Silk Tulle Scarf",
// "Ocean Blue Glitter Mini Bag"); the tiles keep the color alone (Vic, round 48)
// Round 67 (Vic: "make the first line text consistently "Silk Tulle Skirt and Top, (Color)" instead of Color first"): the
// main line names the pieces first and her color after (the scarf and the bag keep their titles)
const setTitle = (c) => SET.data.pieces + ', ' + c.name;
const giftTitle = (o, fallback) => (o ? o.title || o.name : fallback);
// the sizes in the order the site prefers (assets/hb-qv.js): M first, then the nearest
const SIZE_RANK = ['M', 'L', 'S', 'XL', 'XS', 'XXL', 'XXS', 'XXXL', '3XL'];
function rememberedSize() {
  try {
    return String(localStorage.getItem('hb-size') || '')
      .trim()
      .toUpperCase();
  } catch (e) {
    return '';
  }
}

// The shop's money format, learned from two amounts Liquid rendered (1,000 and 1,234.56 in her currency)
function moneyFormatter(samples) {
  const strip = (h) => String(h || '').replace(/<[^>]+>/g, '');
  const wrap = String(samples && samples[0] ? samples[0] : '').match(/^\s*(<[^>]+>)([\s\S]*?)(<\/[^>]+>)\s*$/);
  const open = wrap ? wrap[1] : '';
  const shut = wrap ? wrap[3] : '';
  const b = strip(samples && samples[1]);
  let m = b.match(/^([\s\S]*?)1(\D?)234(\D)56([\s\S]*)$/);
  let prefix = '';
  let suffix = '';
  let thousands = ',';
  let decimal = '.';
  let decimals = true;
  if (m) {
    prefix = m[1];
    thousands = m[2];
    decimal = m[3];
    suffix = m[4];
  } else {
    m = b.match(/^([\s\S]*?)1(\D?)235([\s\S]*)$/) || b.match(/^([\s\S]*?)1(\D?)234([\s\S]*)$/);
    decimals = false;
    if (m) {
      prefix = m[1];
      thousands = m[2];
      suffix = m[3];
    }
  }
  return (cents) => {
    const n = Math.round(Number(cents) || 0);
    const whole = Math.floor(n / 100);
    const frac = n % 100;
    const int = String(whole).replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
    const tail = decimals && frac ? decimal + String(frac).padStart(2, '0') : '';
    return open + prefix + int + tail + suffix + shut;
  };
}

// the set's lines, in order (round 71: from the set's definition)
function setSteps() {
  const d = SET.data;
  const c = d.colors[SET.color];
  const steps = ['color'];
  if (d.kind === 'pair') {
    if (c && c.main.vars.length > 1) steps.push('length');
  } else steps.push('size');
  if (!d.lock2 && d.seconds.length) steps.push('second');
  if (d.addon && d.addons.length) steps.push('addon');
  if (d.scarfOn && d.scarves.length) steps.push('scarf');
  if (d.bagOn && d.bags.length) steps.push('bag');
  if (d.pinsOn && d.pins.length) steps.push('pins');
  return steps;
}

// the main piece's variant for a key ("Regular", "M", "M/S")
function mainVar(c, k) {
  return c ? c.main.vars.find((v) => v.k === k) || null : null;
}
// the reduced top's size for the chosen top
function addonVar(a, k) {
  return a ? a.sizes.find((v) => v.name === k) || null : null;
}

function setPick() {
  const d = SET.data;
  const c = d.colors[SET.color];
  const main = mainVar(c, SET.mk) || (c ? c.main.vars[0] : null);
  const second = c ? (d.lock2 ? c.second : d.seconds[SET.second] || null) : null;
  const addonItem = d.addon ? d.addons[SET.addon] || null : null;
  const addonSize = addonItem ? addonVar(addonItem, SET.ak) || addonItem.sizes[0] || null : null;
  const scarf = d.scarfOn && d.scarves[SET.scarf] && !d.scarves[SET.scarf].out ? d.scarves[SET.scarf] : null;
  const bag = d.bagOn && d.bags[SET.bag] && !d.bags[SET.bag].out ? d.bags[SET.bag] : null;
  const pins = d.pinsOn ? SET.pins.map((i) => d.pins[i]).filter(Boolean) : [];
  const pct = d.addon ? Number(d.addon.pct) || 0 : 0;
  const addonFull = addonSize ? addonSize.cents : 0;
  // rounded down, as the Function reduces it (03_Operations/Shopify/Gift_Discount_Function)
  const addonNow = addonSize ? addonFull - Math.floor((addonFull * pct) / 100) : 0;
  const base = c ? (main ? main.cents : 0) + (second ? second.cents : 0) : 0;
  const total = base + addonNow;
  const was = base + addonFull + (scarf ? scarf.cents : 0) + (bag ? bag.cents : 0) + pins.reduce((s, p) => s + p.cents, 0);
  // the set can go in: the main piece in stock, and its second piece (required with it when the colour locks it)
  const mainOk = !!(main && main.avail) && (!d.lock2 || !!second) && (!second || !!second.avail);
  return { c, main, len: main, second, addonItem, addonSize, addon: addonItem && addonSize ? addonItem : null, scarf, bag, pins, total, was, mainOk, pct, addonNow, addonFull };
}

// Her first choice on the main piece: the pair's Regular (the sizes are elsewhere on the site, Vic round 52), else the
// first in stock; a swimsuit's or a bikini's size M, or her remembered size when it is in stock (the product page's
// rule, principle 5), on each axis
function pickSize(values, inStock) {
  const pref = rememberedSize();
  const ok = (v) => inStock(v);
  if (pref && values.some((v) => v.toUpperCase() === pref && ok(v))) return values.find((v) => v.toUpperCase() === pref);
  for (const r of SIZE_RANK) {
    const hit = values.find((v) => v.toUpperCase() === r && ok(v));
    if (hit) return hit;
  }
  return values.find(ok) || values[0] || '';
}
function defaultMain(c) {
  if (!c) return '';
  const vars = c.main.vars;
  if (SET.data.kind === 'pair') {
    const reg = vars.find((v) => v.avail && /regular/i.test(v.name));
    if (reg) return reg.k;
    const any = vars.find((v) => v.avail);
    return any ? any.k : vars[0] ? vars[0].k : '';
  }
  const axes = c.main.axes || [];
  if (axes.length === 1) {
    const k = pickSize(axes[0].values, (v) => !!vars.find((x) => x.k === v && x.avail));
    return k;
  }
  if (axes.length >= 2) {
    const t = pickSize(axes[0].values, (v) => vars.some((x) => x.k.split('/')[0] === v && x.avail));
    const b = pickSize(axes[1].values, (v) => vars.some((x) => x.k === t + '/' + v && x.avail));
    const k = t + '/' + b;
    if (vars.some((x) => x.k === k && x.avail)) return k;
  }
  const any = vars.find((v) => v.avail);
  return any ? any.k : vars[0] ? vars[0].k : '';
}
// the reduced top's size: her remembered size, else M, among the sizes in stock
function defaultAddonSize(a) {
  if (!a) return '';
  return pickSize(
    a.sizes.map((v) => v.name),
    (v) => !!a.sizes.find((x) => x.name === v && x.avail)
  );
}
// the piece of her set's colour in a list (the Silk Tulle Scarf of her colour, the Bandeau Top of her colour, the Knit
// Belted Top of her colour: "Ocean" for "Ocean Glitter"), else -1
function ofColour(list, c) {
  if (!c || !Array.isArray(list)) return -1;
  const cn = c.name.toLowerCase();
  let i = list.findIndex((o) => o.name.toLowerCase() === cn);
  if (i < 0) i = list.findIndex((o) => cn.indexOf(o.name.toLowerCase()) === 0 || o.name.toLowerCase().indexOf(cn) === 0);
  return i;
}

// White first and Black last, the others as Theme settings list them (Vic, round 52: "Always start with White color and
// end with Black"); the scarves in the same order. A stable sort, so the middle keeps its order. Round 74: a set's lead
// colour (d.lead, snippets/hb-set-look-key: Taupe for the swimsuit sets) goes before them all, as the band shows it.
function orderColours(d) {
  const lead = String(d.lead || '').trim().toLowerCase();
  const rank = (n) => (lead && String(n).trim().toLowerCase() === lead ? -1 : /^white$/i.test(String(n).trim()) ? 0 : /^black$/i.test(String(n).trim()) ? 2 : 1);
  d.colors.sort((a, b) => rank(a.name) - rank(b.name));
  if (Array.isArray(d.scarves)) d.scarves.sort((a, b) => rank(a.name) - rank(b.name));
}

// Round 89 (Vic, 23 Oct: "The customer only finds out that the Silk Tulle Scarf (White) is sold out at the very last
// step. It would be better to show this as soon as the customer selects it"): what her cart holds, by variant, so a piece
// whose last ones are in her cart already ("max", snippets/hb-set-json) shows as out from the start, not at the add
function heldInCart() {
  return fetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
    .then((r) => (r.ok ? r.json() : null))
    .then((cart) => {
      const m = new Map();
      ((cart && cart.items) || []).forEach((i) => m.set(Number(i.variant_id), (m.get(Number(i.variant_id)) || 0) + Number(i.quantity || 0)));
      return m;
    })
    .catch(() => null);
}
// the map, or null when the cart has not answered within ms (the builder then opens at once and is marked when it does)
function heldWithin(p, ms) {
  return Promise.race([p, new Promise((r) => setTimeout(() => r(null), ms))]);
}
// Round 90 (Vic: "please just cross out any product that is sold out (or would be sold out with the one in her existing
// cart)"): the scarves, the bags and the second pieces the store has sold out come in the list too (snippets/hb-set-json,
// "avail": false) and are crossed out like the ones her cart holds the last of
function markSold(d) {
  [d.scarves, d.bags, d.seconds].forEach((list) =>
    list.forEach((o) => {
      if (o && o.avail === false) o.out = true;
    })
  );
}
// marks the pieces she cannot add one more of: avail false (the pills strike them), out (the tiles); true when one is
function markHeld(d, held) {
  if (!d || !held || !held.size) return false;
  let any = false;
  const tag = (v) => {
    if (!v || typeof v.max !== 'number') return;
    const n = held.get(Number(v.id)) || 0;
    if (n + 1 <= v.max) return;
    v.avail = false;
    v.out = true;
    any = true;
  };
  d.colors.forEach((c) => {
    if (c.main && Array.isArray(c.main.vars)) c.main.vars.forEach(tag);
    tag(c.second);
  });
  d.seconds.forEach(tag);
  d.addons.forEach((a) => (Array.isArray(a.sizes) ? a.sizes : []).forEach(tag));
  d.scarves.forEach(tag);
  return any;
}
// her picks moved off a piece that is out (after markHeld)
function fixPicks() {
  const d = SET.data;
  const c = d && d.colors[SET.color];
  if (!c) return;
  const m = mainVar(c, SET.mk);
  if (!m || !m.avail) SET.mk = defaultMain(c);
  const se = d.seconds[SET.second];
  if (se && se.out) {
    const i = d.seconds.findIndex((x) => !x.out);
    if (i >= 0) SET.second = i;
  }
  const a = d.addons[SET.addon];
  if (a) {
    const v = addonVar(a, SET.ak);
    if (!v || !v.avail) SET.ak = defaultAddonSize(a);
  }
  const sc = d.scarves[SET.scarf];
  if (sc && sc.out) SET.scarf = matchScarf(c);
  const b = d.bags[SET.bag];
  if (b && b.out) {
    const i = d.bags.findIndex((x) => !x.out);
    if (i >= 0) SET.bag = i;
  }
}

function matchScarf(c) {
  const i = scarfOfColour(c);
  const list = SET.data.scarves;
  if (i >= 0 && !list[i].out) return i;
  // round 89: her colour's scarf is out (her cart holds the last of it): the first she can still have
  const j = list.findIndex((sc) => !sc.out);
  return j >= 0 ? j : i < 0 ? 0 : i;
}
function scarfOfColour(c) {
  // the scarf in the set's own colour, or -1 when none is in stock
  return SET.data.scarves.findIndex((sc) => sc.name.toLowerCase() === c.name.toLowerCase());
}

// the set a band or a link asks for (round 71): the band's data-hb-set-key, ?hb_set=<key>, else the Silk Tulle Set
const DEFAULT_SET = 'silk-tulle';
function setKeyOf(opener) {
  const el = opener && opener.closest ? opener.closest('[data-hb-set-key]') : null;
  return (el && el.getAttribute('data-hb-set-key')) || DEFAULT_SET;
}

// HB 2026-10-20 (the looks, assets/hb-look.js), carried from RESORT LAUNCH on 2 Nov: opts.start opens the builder on its
// colour line, as the reel's BUILD MY SET does, when the sheet she comes from has said what the first page says
function openSet(opener, key, opts) {
  S.wantKey = key || setKeyOf(opener);
  // HB 2026-11-02: a colour tapped on the band (opts.start) rises as the sheet does; the grow is for the first page
  S.grow = opts && opts.start ? null : growFrom(opener);
  if (!open('set', opener)) {
    S.grow = null;
    return;
  }
  const d = dlg();
  d.setAttribute('aria-label', 'Your set');
  setHead({});
  // growing: the band's picture fills the panel until the builder is in (at once when its section is fetched already)
  q('[data-hb-sl-body]', d).innerHTML = S.grow
    ? '<div class="hb-sl__grow"><img class="hb-sl__growimg" src="' + esc(S.grow.src) + '" alt="" decoding="sync"></div>'
    : '<div class="hb-sl__wait hb-sl__wait--set"><div class="hb-sl__wait-name">One moment.</div></div>';
  q('[data-hb-sl-foot]', d).innerHTML = '';
  if (S.grow) {
    growStart(q('.hb-sl__growimg', d));
    // Round 75 (Vic: the grow "feels quite laggy. She moves a bit left first, and then snaps into place"): the builder
    // used to mount in the same task as the tap, before the picture's first frame, and its placeholder's box was not the
    // first page's (100 % high against 94.5 %), so the picture jumped twice as it landed. Now the tap does only the
    // grow (the picture and the clip, both on the compositor), and the builder mounts after two frames: loadSet waits
    // for the grow to land (the picture then stays where it is, pixel for pixel), the first page's words fade in after.
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        if (S.open && S.mode === 'set') loadSet(opts);
      });
    });
  } else loadSet(opts);
}

// Round 63 (Vic, on the phone: "Can you also make the builder "grow out" from the picture, instead of just sliding up
// from the bottom? If it helps you you can keep the same picture on full-width tile and on the first page of the
// builder"): from the band, the sheet opens as the band's picture growing to the whole screen. The picture starts
// exactly where the band shows it (the same file, the same crop) and settles to the first page's place; its frame opens
// from the band's to the screen on the same curve; the x and the words come in as it lands. Phone only, from a band
// whose picture is loaded, never with reduced motion (the sheet rises as before).
// Round 75 (Vic: the grow "feels quite laggy. She moves a bit left first, and then snaps into place further to the
// right"): the frame used to open as a clip-path on the panel, which Safari animates on the main thread (WebKit bug
// 185816, still open), so any work during the grow (the page lock, the builder's mount, a decode) held the frame while
// the picture, on the compositor, went on; and the placeholder picture's own box was not the first page's, so it jumped
// as it landed. Now the frame is the picture's wrapper (overflow hidden) moved and scaled by transform, and the
// picture inside is counter-scaled so it is never distorted; both run as Web Animations with the same pre-eased
// keyframes, entirely on the compositor, and the builder mounts only once the picture has landed (openSet). The panel
// is transparent while it grows, so outside the frame the page stays as it was.
const GROW_MS = 560;
const GROW_N = 40; // keyframes, the curve of round 63 baked into them
// cubic-bezier(0.22, 0.8, 0.2, 1), solved for y at a time x (the same curve as the CSS easing used before)
function growEase(x) {
  const p1x = 0.22, p1y = 0.8, p2x = 0.2, p2y = 1;
  const bx = (t) => 3 * p1x * (1 - t) * (1 - t) * t + 3 * p2x * (1 - t) * t * t + t * t * t;
  const by = (t) => 3 * p1y * (1 - t) * (1 - t) * t + 3 * p2y * (1 - t) * t * t + t * t * t;
  if (x <= 0) return 0;
  if (x >= 1) return 1;
  let lo = 0;
  let hi = 1;
  let t = x;
  for (let i = 0; i < 24; i++) {
    const v = bx(t);
    if (Math.abs(v - x) < 1e-5) break;
    if (v < x) lo = t;
    else hi = t;
    t = (lo + hi) / 2;
  }
  return by(t);
}
function growFrom(opener) {
  if (!phone() || !(opener instanceof Element)) return null;
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return null;
  if (typeof Element.prototype.animate !== 'function') return null;
  const band = opener.closest('.hb-band');
  const img = (opener.querySelector && opener.querySelector('img.hb-band__img')) || (band && (band.querySelector('.hb-band__img--main') || band.querySelector('.hb-band__img')));
  if (!img || !img.complete || !img.naturalWidth) return null;
  const r = img.getBoundingClientRect();
  if (r.width < 40 || r.height < 40 || r.bottom < 0 || r.top > window.innerHeight) return null;
  const pos = String(getComputedStyle(img).objectPosition || '').split(' ');
  const py = /%$/.test(pos[1] || '') ? parseFloat(pos[1]) / 100 : 0.18;
  return { r: { x: r.left, y: r.top, w: r.width, h: r.height }, src: img.currentSrc || img.src, nw: img.naturalWidth, nh: img.naturalHeight, py, img: null, wrap: null, kf: null, ran: false, ended: false };
}
// the picture laid over the band's: its box is the picture exactly as the first page draws it (the box the CSS gives it
// once the inline styles go, so the hand-back changes nothing); the wrapper (overflow hidden) is the frame, moved and
// scaled from the band's frame to the whole box; the picture is moved and counter-scaled inside it so it is drawn, frame
// by frame, from the band's drawing to the first page's. The first keyframe is set at once (the band's drawing, under
// the band's own picture), growRun starts the two animations on the next frame.
const GROW_BOX = ['left', 'top', 'right', 'bottom', 'width', 'height', 'aspectRatio', 'maxWidth', 'maxHeight', 'transform', 'transformOrigin', 'transition', 'willChange'];
function growStart(img) {
  const g = S.grow;
  const panel = q('[data-hb-sl-panel]');
  if (!g || g.ran || !img || !panel) return;
  const wrap = img.parentElement || panel;
  const W = wrap.clientWidth || panel.clientWidth;
  const Hb = wrap.clientHeight || panel.clientHeight;
  // round 69: on the phone the first page draws the picture 94.5 % of the screen's height (the feet about 10 % from
  // the foot), so the grow lands there
  const PIC = phone() ? 0.945 : 1;
  const H = Hb * PIC;
  const B = wrap.getBoundingClientRect();
  const pos = String(getComputedStyle(img).objectPosition || '').split(' ');
  const px = /%$/.test(pos[0] || '') ? parseFloat(pos[0]) / 100 : 0.5;
  const py = /%$/.test(pos[1] || '') ? parseFloat(pos[1]) / 100 : 0.12;
  // where the first page draws the whole picture (object-fit: cover in its box)
  const sB = Math.max(W / g.nw, H / g.nh);
  const bw = g.nw * sB;
  const bh = g.nh * sB;
  const bx = (W - bw) * px;
  const by = (H - bh) * py;
  // where the band drew it, in the same box's terms
  const sR = Math.max(g.r.w / g.nw, g.r.h / g.nh);
  const rw = g.nw * sR;
  const rh = g.nh * sR;
  const rx = g.r.x - B.left + (g.r.w - rw) * 0.5;
  const ry = g.r.y - B.top + (g.r.h - rh) * g.py;
  // the frame: the band's, in the box's terms, to the whole box
  const c0 = { x: g.r.x - B.left, y: g.r.y - B.top, w: g.r.w, h: g.r.h };
  const kfWrap = [];
  const kfImg = [];
  for (let i = 0; i <= GROW_N; i++) {
    const t = growEase(i / GROW_N);
    const cx = c0.x * (1 - t);
    const cy = c0.y * (1 - t);
    const sx = (c0.w + (W - c0.w) * t) / W;
    const sy = (c0.h + (Hb - c0.h) * t) / Hb;
    const dx = rx + (bx - rx) * t;
    const dy = ry + (by - ry) * t;
    const k = (rw + (bw - rw) * t) / bw;
    kfWrap.push({ transform: 'translate(' + cx.toFixed(2) + 'px,' + cy.toFixed(2) + 'px) scale(' + sx.toFixed(5) + ',' + sy.toFixed(5) + ')' });
    const tx = (dx - cx) / sx - bx;
    const ty = (dy - cy) / sy - by;
    kfImg.push({ transform: 'translate(' + tx.toFixed(2) + 'px,' + ty.toFixed(2) + 'px) scale(' + (k / sx).toFixed(5) + ',' + (k / sy).toFixed(5) + ')' });
  }
  img.style.transition = 'none';
  img.style.right = 'auto';
  img.style.bottom = 'auto';
  img.style.maxWidth = 'none'; // the theme caps pictures at their box's width
  img.style.maxHeight = 'none';
  img.style.left = bx.toFixed(2) + 'px';
  img.style.top = by.toFixed(2) + 'px';
  img.style.width = bw.toFixed(2) + 'px';
  img.style.height = bh.toFixed(2) + 'px';
  img.style.transformOrigin = '0 0';
  img.style.transform = kfImg[0].transform;
  wrap.style.transformOrigin = '0 0';
  wrap.style.transform = kfWrap[0].transform;
  wrap.style.willChange = 'transform';
  img.style.willChange = 'transform';
  void img.offsetWidth;
  g.img = img;
  g.wrap = wrap;
  g.kf = { wrap: kfWrap, img: kfImg };
}
function growRun() {
  const g = S.grow;
  if (!g || g.ran) return;
  g.ran = true;
  g.done = new Promise((res) => (g.finish = res));
  const img = g.img;
  const wrap = g.wrap;
  let aw = null;
  let ai = null;
  if (img && wrap && g.kf) {
    const opts = { duration: GROW_MS, easing: 'linear', fill: 'forwards' };
    try {
      aw = wrap.animate(g.kf.wrap, opts);
      ai = img.animate(g.kf.img, opts);
    } catch (e) {
      aw = ai = null;
    }
  }
  const end = () => {
    if (g.ended) return;
    g.ended = true;
    // the box back to the CSS's (the same drawing: the whole picture at the same place, cropped by its wrapper)
    try {
      if (aw) aw.cancel();
      if (ai) ai.cancel();
    } catch (e) {
      /* nothing */
    }
    if (wrap) {
      wrap.style.transform = '';
      wrap.style.transformOrigin = '';
      wrap.style.willChange = '';
    }
    if (img) GROW_BOX.forEach((k) => (img.style[k] = ''));
    if (g.finish) g.finish();
    if (S.grow !== g) return;
    S.growing = false;
    dlg().classList.remove('is-growing');
  };
  if (ai && ai.finished && typeof ai.finished.then === 'function') ai.finished.then(end, end);
  setTimeout(end, GROW_MS + 80);
}

// Round 63: the builder's section fetched ahead once a band comes near the screen (init), so a tap grows straight into
// the builder (its picture, the band's, is on at once)
let setAhead = null;
function prefetchSet() {
  if (S.setHtml || setAhead) return;
  setAhead = fetch('/?section_id=hb-set', { credentials: 'same-origin' })
    .then((res) => (res.ok ? res.text() : ''))
    .then((h) => {
      if (h && !S.setHtml) S.setHtml = h;
      return S.setHtml || '';
    })
    .catch(() => '')
    .finally(() => {
      setAhead = null;
    });
}

// opts.start: straight to the colour line (the reel's BUILD MY SET: its last card is the first page already)
async function loadSet(opts) {
  const my = ++S.req;
  const heldP = heldInCart(); // round 89
  let html = S.setHtml;
  // round 63: the fetch ahead (prefetchSet), when it is still on its way
  if (!html && setAhead) html = await setAhead;
  if (!html) {
    try {
      const res = await fetch('/?section_id=hb-set', { credentials: 'same-origin' });
      if (!res.ok) throw new Error('hb-set ' + res.status);
      html = await res.text();
      S.setHtml = html;
    } catch (e) {
      html = '';
    }
  }
  // round 64: a builder that arrives while the band's picture is still growing waits for it to land; its first page is
  // the same picture in the same place, so the swap is then invisible (before, it took over mid-way: the snap)
  if (S.grow && S.grow.ran && S.growing && S.grow.done) await S.grow.done;
  if (my !== S.req || !S.open) return;
  const doc = new DOMParser().parseFromString(html, 'text/html');
  const el = doc.querySelector('[data-hb-set]');
  let all = null;
  try {
    all = el ? JSON.parse(el.querySelector('[data-hb-set-data]').textContent) : null;
  } catch (e) {
    all = null;
  }
  // round 71: the set the band asked for, out of the sets the section lists (each the same shape)
  const want = S.wantKey || DEFAULT_SET;
  const sets = all && Array.isArray(all.sets) ? all.sets : [];
  const data = sets.find((s) => s && s.key === want) || null;
  if (!el || !data || !Array.isArray(data.colors) || !data.colors.length) {
    q('[data-hb-sl-body]').innerHTML = '<div class="hb-sl__wait hb-sl__wait--set"><div class="hb-sl__wait-name">The set is not available right now.</div></div>';
    return;
  }
  data.ship = all.ship;
  data.money = all.money;
  data.nonEu = all.nonEu;
  data.cc = all.cc;
  data.seconds = Array.isArray(data.seconds) ? data.seconds : [];
  data.addons = Array.isArray(data.addons) ? data.addons : [];
  data.scarves = Array.isArray(data.scarves) ? data.scarves : [];
  data.bags = Array.isArray(data.bags) ? data.bags : [];
  data.pins = Array.isArray(data.pins) ? data.pins : [];
  orderColours(data);
  // round 89: what her cart holds, when it answers within 400 ms (else below, once it does)
  const held = await heldWithin(heldP, 400);
  if (my !== S.req || !S.open) return;
  markSold(data); // round 90
  if (held) markHeld(data, held);
  SET.data = data;
  SET.fmt = moneyFormatter(data.money);
  SET.color = 0;
  const c0 = data.colors[0];
  SET.mk = defaultMain(c0);
  SET.second = Math.max(0, ofColour(data.seconds, c0));
  SET.addon = Math.max(0, ofColour(data.addons, c0));
  SET.ak = defaultAddonSize(data.addons[SET.addon]);
  SET.scarf = matchScarf(c0);
  SET.bag = 0;
  fixPicks();
  // HB 2026-11-02 (Olivia, the band's six colours, option C): a colour tapped on the band opens the builder on it, the
  // picks following that colour as a tap on its dot would (setColour)
  const wantC = opts && opts.color ? String(opts.color).trim().toLowerCase() : '';
  if (wantC) {
    const ci = data.colors.findIndex((c) => String(c && c.name).trim().toLowerCase() === wantC);
    if (ci > 0) {
      const cw = data.colors[ci];
      SET.color = ci;
      SET.mk = defaultMain(cw);
      SET.second = Math.max(0, ofColour(data.seconds, cw));
      SET.addon = Math.max(0, ofColour(data.addons, cw));
      SET.ak = defaultAddonSize(data.addons[SET.addon]);
      SET.scarf = matchScarf(cw);
      fixPicks();
    }
  }
  SET.pins = [];
  SET.busy = false;
  // Round 82 (Vic, 22 Oct: "How about we remove the front page entirely on Desktop? So it starts with Silk Tulle Skirt
  // and Top folded out and color options visible to choose"): on desktop the builder opens on the colour line; the
  // phone keeps its first page
  SET.intro = !(opts && opts.start) && phone();
  SET.receipt = false;
  SET.bg = '';
  SET.bgi = -1;
  SET.dark = setWant() === 3; // round 68: Option 3, Option 2's builder in the dark
  SET.ac = 'color';
  SET.acDone = {};
  SET.acRest = '';
  SET.endLook = setEndLook();
  SET.scarfSeen = false;
  SET.clip = '';
  SET.lenOpen = false;
  SET.lenShown = false;
  SET.seenEnd = false;
  // the first page's picture: the band's own as she saw it (round 63), else the section's, else her colour's look
  SET.introSrc = (S.grow && S.grow.src) || data.intro || '';
  mountSet(el);
  // round 89: a slow cart marks the builder once it answers
  if (!held)
    heldP.then((h) => {
      if (my !== S.req || !S.open || SET.data !== data || SET.busy) return;
      if (markHeld(data, h)) {
        fixPicks();
        paintSet();
      }
    });
}

function mountSet(el) {
  const d = dlg();
  const body = q('[data-hb-sl-body]', d);
  const foot = q('[data-hb-sl-foot]', d);
  body.innerHTML = '';
  // Round 47: the builder's foot stays inside it, over the picture; the sheet's white foot is not used in set mode
  foot.innerHTML = '';
  foot.hidden = true;
  if (S.leaveFit) {
    q('[data-hb-sl-back]', d).removeEventListener('click', S.leaveFit);
    S.leaveFit = null;
  }
  body.appendChild(el);
  body.scrollTop = 0;
  SET.el = el;
  SET.foot = el.querySelector('[data-hb-set-foot]');
  el.dataset.cta = SET.data.cta || 'Build my set';
  d.setAttribute('aria-label', SET.data.cap || 'Your set');
  // The head's Back: the line before, the last line once all are chosen, the first page from the first line; round 63
  // (Vic: "Remove < Back button"): not on the phone, where a swipe down or a tap on a line goes back; round 92 (Vic:
  // "add "Back" button in top left"): on the phone again, on every page, and from the first page it closes the builder
  const back = q('[data-hb-sl-back]', d);
  const leave = () => {
    if (S.mode !== 'set' || !SET.el || SET.busy) return;
    if (SET.intro) {
      if (phone()) close();
      return;
    }
    const lines = acLines(setSteps());
    const i = lines.indexOf(SET.ac);
    if (!SET.ac) openLine(SET.acRest || lines[lines.length - 1]);
    else if (i > 0) openLine(lines[i - 1]);
    else if (phone()) showFirst(); // round 82: no first page on desktop
  };
  S.leaveFit = leave; // cleared on close like the Fit pane's
  back.addEventListener('click', leave);
  el.addEventListener('click', onSetClick);
  setGestures(el);
  // round 63: any touch, click, wheel or key wakes the last page's lines and starts its 5 s again (calmArm)
  const wake = (e) => {
    // round 85 (Vic: "When on final rest page, then clicking 'Continue to checkout' doesn't go to checkout but opens
    // options again"): a tap on the pill while the page rests leaves the page at rest, so the pill stays under her
    // finger and the tap goes to the checkout (before, the lines came back first and moved it)
    if (calm.on && e && e.target instanceof Element && e.target.closest('[data-hb-set-cta]')) return;
    if (calm.on) calmWake();
    calmArm();
  };
  ['touchstart', 'pointerdown', 'wheel', 'keydown'].forEach((t) => el.addEventListener(t, wake, { passive: true, capture: true }));
  paintSet();
  track('hb_sheet_step', { flow: 'set', set: SET.data.key, v: setVn(), step: SET.intro ? 'intro' : SET.ac });
  // the other colours' looks, so a tap on a dot swaps the picture at once
  setTimeout(preloadLooks, 600);
}

// "Build my set": the first line
function startSet() {
  if (!SET.el || !SET.intro || SET.busy) return;
  openLine('color');
}

// Round 55 (Vic: "a scroll down or scroll right on first page functions also as pressing BUILD MY SET"), widened in
// round 57 to the whole builder and redrawn in round 58 (Vic, on his iPhone: "if I have scrolled down to make my
// selection, then I would also like to scroll back up to go back to it. Therefore we need the closing to be just the top
// 20% approx. (closing currently feels unsmooth, a bit laggy) ... scrolling up in the middle of the screen takes me to
// previous step"; "On right-scroll or left-scroll, this should please change the color selection of Skirt & Top"). On
// the phone, in both options:
//   a pull down that starts in the top 20 % of the screen (above the words) closes the builder, the sheet following the
//   finger frame by frame (no easing behind it, the glass effects off while it moves);
//   a swipe up (the page scrolled down) confirms, as the white pill does; on the last page it never goes to the checkout:
//   the pill answers instead (Vic's five mockups, ?hb_set_end=1 to 5);
//   a swipe down lower on the screen (the page scrolled up) goes back a step, as Back does;
//   on the colour step a swipe to the left brings the next colour, to the right the one before, the picture sliding with
//   it; on the first page a swipe to the left still starts the set (round 55); round 63 (Vic: "even if Skirt + Top color
//   line is closed, then scrolling left or right should change the color of Skirt + Top and Scarf if this has already
//   been selected before"): sideways changes the colour on every step and line, the last page too;
//   a swipe counts from 60 px, mostly along one axis; one that starts on the colour dots, the length or the tiles, or a
//   sideways one within 24 px of the screen's side (the phone's own back), counts for nothing.
// On desktop the wheel or the trackpad do nothing in the builder (round 84, Vic: "Scrolling on desktop should not count
// as a button click", "Scrolling right or left or up or down should not move the selector at all"; before, down
// confirmed and up went back, once per movement).
const GEST = { min: 60, ratio: 1.4, edge: 24, top: 0.2, close: 80, flick: 40, flickMs: 300 };
const GEST_PICK = '.hb-sb__dots, .hb-sb__tiles, .hb-sb__lens, .hb-sb__pills';

// the last page: the total and the checkout
function onLastPage() {
  return !!SET.el && !SET.intro && acAll();
}

// The sheet follows a pull down frame by frame (shared by the head's drag and the builder's): no transition behind the
// finger, the glass effects off while it moves (each frame redrew them: the lag Vic felt); a close continues from where
// the finger let go
const drag = { panel: null, y: 0, raf: 0 };
function dragTo(dy) {
  const panel = q('[data-hb-sl-panel]');
  if (!panel) return;
  if (!drag.panel) {
    drag.panel = panel;
    dlg().classList.add('is-drag');
    panel.style.transition = 'none';
  }
  drag.y = Math.max(0, Math.min(dy, 400));
  if (!drag.raf)
    drag.raf = requestAnimationFrame(() => {
      drag.raf = 0;
      if (drag.panel) drag.panel.style.transform = 'translate3d(0,' + drag.y + 'px,0)';
    });
}
function dragEnd(closeIt) {
  const panel = drag.panel;
  if (drag.raf) cancelAnimationFrame(drag.raf);
  drag.raf = 0;
  drag.panel = null;
  if (!panel) {
    if (closeIt) close();
    return;
  }
  panel.style.transition = closeIt ? 'transform 0.24s cubic-bezier(0.3, 0.6, 0.4, 1)' : 'transform 0.28s cubic-bezier(0.2, 0.8, 0.2, 1)';
  panel.style.transform = '';
  if (closeIt) close();
  setTimeout(() => {
    panel.style.transition = '';
    dlg().classList.remove('is-drag');
  }, closeIt ? SHEET_MS + 60 : 300);
}

// the white pill's step can be taken now (not on the last page, not while the set goes in, not with her size sold out)
function setCanAdvance() {
  if (!SET.el || !SET.data || SET.busy) return false;
  if (SET.intro) return true;
  const p = setPick();
  if (!p.c || !p.mainOk) return false;
  return !acAll();
}
// the white pill's step: the first page's Build my set, else the next line
function setAdvance() {
  if (!setCanAdvance()) return false;
  if (SET.intro) {
    startSet();
    return true;
  }
  if (SET.ac) SET.acDone[SET.ac] = true;
  const lines = acLines(setSteps());
  openLine(lines.find((k) => !SET.acDone[k]) || '');
  return true;
}

function setGestures(el) {
  const body = q('[data-hb-sl-body]');
  const still = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const atEnd = () => !body || body.scrollTop + body.clientHeight >= body.scrollHeight - 2;
  const atTop = () => !body || body.scrollTop <= 0;
  // where the words begin: the first page's, or the step's (Option 2: the card or the first line)
  const wordsTop = () => {
    const box = SET.intro ? q('[data-hb-set-first]', el) : q('[data-hb-set-panel]', el);
    // (the first that shows: an empty card slot is hidden)
    for (const kid of box ? box.children : []) {
      const r = kid.getBoundingClientRect();
      if (r.height > 0) return r.top;
    }
    return Infinity;
  };
  const picNow = () => {
    const imgs = el.querySelectorAll('[data-hb-set-bgimg]');
    return imgs[SET.bgi] || null;
  };
  let g = null;
  let lifted = null;
  let pulled = null;
  const settle = () => {
    if (lifted) {
      const b = lifted;
      lifted = null;
      b.style.transition = 'transform 0.2s ease';
      b.style.transform = '';
      b.classList.remove('is-ready');
      setTimeout(() => b.style.removeProperty('transition'), 220);
    }
  };
  const unpull = (keep) => {
    const im = pulled;
    pulled = null;
    if (!im || keep) return;
    im.style.transition = 'transform 0.25s ease';
    im.style.transform = '';
    setTimeout(() => {
      if (!pulled) im.style.transition = '';
    }, 260);
  };
  // the pill (Back, for a step back) moves a little toward the finger, at most 4 px; at the line it is ready
  const lift = (kind, p) => {
    const b = kind === 'back' ? q('[data-hb-sl-back]') : q(SET.intro ? '[data-hb-set-start]' : '[data-hb-set-cta]', el);
    if (lifted && lifted !== b) settle();
    if (!b || still) return;
    lifted = b;
    b.style.transition = 'none';
    b.style.transform = kind === 'back' ? 'translateY(' + (4 * p).toFixed(1) + 'px)' : 'translateY(' + (-4 * p).toFixed(1) + 'px)';
    b.classList.toggle('is-ready', p >= 1);
  };
  const kindOf = (dx, dy) => {
    const ax = Math.abs(dx);
    const ay = Math.abs(dy);
    if (!g || g.pick) return '';
    if (ay >= ax * GEST.ratio) {
      if (dy > 0) {
        if (g.top) return g.first ? 'close' : '';
        return SET.intro || !g.first ? '' : 'back';
      }
      if (!g.end) return '';
      if (onLastPage()) return 'end';
      return setCanAdvance() ? 'next' : '';
    }
    if (ax >= ay * GEST.ratio && !g.side) {
      if (SET.intro) return dx < 0 ? 'next' : '';
      return 'colour';
    }
    return '';
  };
  el.addEventListener(
    'touchstart',
    (e) => {
      settle();
      unpull();
      g = null;
      if (!phone() || e.touches.length !== 1 || SET.busy) return;
      const t = e.touches[0];
      const tgt = e.target instanceof Element ? e.target : null;
      g = {
        x: t.clientX,
        y: t.clientY,
        at: performance.now(),
        top: t.clientY < Math.min(window.innerHeight * GEST.top, wordsTop() - 8),
        first: atTop(),
        end: atEnd(),
        side: t.clientX < GEST.edge || t.clientX > window.innerWidth - GEST.edge,
        pick: !!(tgt && tgt.closest(GEST_PICK)),
      };
    },
    { passive: true }
  );
  el.addEventListener(
    'touchmove',
    (e) => {
      const t = g && e.touches[0];
      if (!t) return;
      const dx = t.clientX - g.x;
      const dy = t.clientY - g.y;
      const kind = Math.max(Math.abs(dx), Math.abs(dy)) > 10 ? kindOf(dx, dy) : '';
      if (kind === 'close') {
        settle();
        if (!still) dragTo(dy);
        return;
      }
      if (drag.panel) dragEnd(false);
      if (kind === 'colour') {
        settle();
        // the picture follows the finger a little (less at the row's ends, where no colour waits)
        const im = picNow();
        const to = SET.color + (dx < 0 ? 1 : -1);
        const free = to >= 0 && to < SET.data.colors.length;
        if (im && !still) {
          pulled = im;
          im.style.transition = 'none';
          im.style.transform = 'translateX(' + (dx * (free ? 0.25 : 0.08)).toFixed(1) + 'px)';
        }
        return;
      }
      if (pulled) unpull();
      if (kind === 'next' || kind === 'back') lift(kind, Math.min(1, Math.max(Math.abs(dx), Math.abs(dy)) / GEST.min));
      else if (kind === 'end' && SET.endLook === '3') endFill(Math.min(1, -dy / (GEST.min * 1.5)));
      else settle();
    },
    { passive: true }
  );
  el.addEventListener(
    'touchend',
    (e) => {
      if (!g) return;
      const p = e.changedTouches[0];
      const dx = p ? p.clientX - g.x : 0;
      const dy = p ? p.clientY - g.y : 0;
      const dt = performance.now() - g.at;
      const kind = kindOf(dx, dy);
      const far = Math.max(Math.abs(dx), Math.abs(dy));
      g = null;
      settle();
      if (kind === 'close') {
        dragEnd(dy >= GEST.close || (dy >= GEST.flick && dt < GEST.flickMs));
        return;
      }
      if (drag.panel) dragEnd(false);
      if (kind === 'colour') {
        const moved = far >= GEST.min && setColour(SET.color + (dx < 0 ? 1 : -1), dx < 0 ? 1 : -1);
        unpull(moved);
        return;
      }
      if (far < GEST.min) {
        if (kind === 'end') endFill(0);
        return;
      }
      if (kind === 'next') setAdvance();
      else if (kind === 'back' && S.leaveFit) S.leaveFit();
      else if (kind === 'end') endAnswer();
    },
    { passive: true }
  );
  el.addEventListener(
    'touchcancel',
    () => {
      g = null;
      settle();
      unpull();
      if (drag.panel) dragEnd(false);
    },
    { passive: true }
  );
  // desktop: once per movement of the wheel or the trackpad (its stream, momentum and all, pauses 250 ms between)
  let w = null;
  el.addEventListener(
    'wheel',
    (e) => {
      if (!phone()) return; // round 84: never on desktop
      if (!w) w = { sum: 0, done: false, timer: 0 };
      const cur = w;
      clearTimeout(cur.timer);
      cur.timer = setTimeout(() => {
        if (w === cur) w = null;
      }, 250);
      if (cur.done) return;
      cur.sum += Math.abs(e.deltaY) >= Math.abs(e.deltaX) ? e.deltaY : 0;
      if (cur.sum > 40 && atEnd()) {
        cur.done = true;
        if (onLastPage()) endAnswer();
        else setAdvance();
      } else if (cur.sum < -40 && atTop()) {
        cur.done = true;
        if (!SET.intro && S.leaveFit) S.leaveFit();
      }
    },
    { passive: true }
  );
}

// Round 58 (Vic: "On final page, if person scrolls down again to proceed, can you make the button bounce a tiny bit to
// indicate that it exists? Or show it turn color to black? Show me 5 mockups quickly, clean and simple"): a swipe up on
// the last page never goes to the checkout; the checkout pill answers, one of five ways, picked for the visit with
// ?hb_set_end=1 to 5 on a collection page: 1 Bounce, 2 Ink (it turns the brand's ink), 3 Fill (a fine ink line fills
// under its words with the swipe, then the whole pill turns ink), 4 Ring (a soft ring pulses out of it), 5 Words (for
// a moment it says: Tap to continue to checkout)
function setEndLook() {
  try {
    const want = new URLSearchParams(location.search).get('hb_set_end');
    if (want !== null) {
      if (/^[1-5]$/.test(want)) sessionStorage.setItem('hb_set_end', want);
      else sessionStorage.removeItem('hb_set_end');
    }
    // round 60 (Vic: "Please for now use 4 - Ring with just 1 pulse"; round 59's Ink before): Ring unless a link asks
    // for another
    return sessionStorage.getItem('hb_set_end') || '4';
  } catch (e) {
    return '4';
  }
}
function endPill() {
  return SET.el && SET.foot ? q('[data-hb-set-cta]', SET.foot) : null;
}
// mockup 3: the line follows the swipe (0 to 1); short of the end it drains again
function endFill(p) {
  const b = endPill();
  if (!b) return;
  b.classList.add('is-fill');
  b.style.setProperty('--hb-fill', p.toFixed(3));
  b.classList.toggle('is-inked', p >= 1);
  if (p <= 0) {
    b.classList.remove('is-fill', 'is-inked');
    b.style.removeProperty('--hb-fill');
  }
}
function endAnswer() {
  const b = endPill();
  if (!b || b.disabled) return;
  const look = SET.endLook;
  track('hb_sheet_end_swipe', { look });
  if (look === '2') {
    b.classList.add('is-inked');
    return;
  }
  if (look === '3') {
    endFill(1);
    return;
  }
  if (look === '5') {
    b.innerHTML = pillIn('Tap to continue to checkout');
    b.classList.add('is-ready', 'is-words');
    clearTimeout(SET.hintT);
    SET.hintT = setTimeout(() => {
      if (SET.el && !SET.busy && onLastPage()) paintSet();
    }, 2600);
    return;
  }
  const cls = look === '4' ? 'is-ring' : 'is-bounce';
  b.classList.remove(cls);
  void b.offsetWidth;
  b.classList.add(cls);
  setTimeout(() => b.classList.remove(cls), 1300);
}

function showFirst() {
  SET.intro = true;
  SET.receipt = false;
  paintSet();
  const body = q('[data-hb-sl-body]');
  if (body) body.scrollTop = 0;
  track('hb_sheet_step', { flow: 'set', step: 'intro' });
}

// The picture behind the builder: two layers, the new one fades in over the old (250 ms), then the old one rests
function setBg(src) {
  const wrap = SET.el && SET.el.querySelector('[data-hb-set-bg]');
  if (!wrap || !src || src === SET.bg) return;
  // round 64 (Vic: "Use White Silk Tulle Set as the front page image ... then when pressing Build My Set it doesn't
  // change the picture"): the same picture at another size (the band's, then the colour step's) stays as it is
  // (the band's address is absolute, the section's protocol-relative: compared without the scheme and the size)
  const file = (u) => String(u || '').replace(/^[a-z]+:/i, '').split('?')[0];
  if (SET.bg && SET.bgi >= 0 && file(src) === file(SET.bg)) return;
  SET.bg = src;
  const imgs = wrap.querySelectorAll('[data-hb-set-bgimg]');
  if (imgs.length < 2) return;
  const n = SET.bgi === 0 ? 1 : 0;
  const img = imgs[n];
  const old = imgs[n ^ 1];
  const tok = ++SET.bgTok;
  // round 63: the first page's picture while the sheet grows out of the band: on at once, laid over the band's picture
  if (S.grow && SET.intro && old && !old.classList.contains('is-on')) {
    img.style.zIndex = '2';
    img.decoding = 'sync';
    img.src = src;
    img.classList.add('is-on');
    img.style.transition = 'none';
    SET.bgi = n;
    if (S.grow && !S.grow.ran) growStart(img);
    else img.style.transition = '';
    return;
  }
  // round 58: a new colour by a swipe or a dot slides in from its side (Vic: "scroll the picture left or right to a new
  // color"), the old one moves the other way under it
  const dir = SET.slide && !(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) ? SET.slide : 0;
  const glide = 'opacity 0.3s ease, transform 0.42s cubic-bezier(0.2, 0.7, 0.2, 1), object-position 0.35s ease';
  img.classList.remove('is-on');
  img.style.zIndex = '2';
  old.style.zIndex = '1';
  img.style.transition = 'none';
  img.style.transform = dir ? 'translateX(' + dir * 16 + '%)' : '';
  img.decoding = 'async';
  img.src = src;
  SET.bgi = n;
  const show = () => {
    if (tok !== SET.bgTok) return;
    if (dir) {
      void img.offsetWidth;
      img.style.transition = glide;
      img.style.transform = 'translateX(0)';
      old.style.transition = glide;
      old.style.transform = 'translateX(' + -dir * 16 + '%)';
    } else img.style.transition = '';
    img.classList.add('is-on');
    setTimeout(() => {
      if (tok !== SET.bgTok) return;
      old.classList.remove('is-on');
      old.style.transform = '';
      old.style.transition = '';
      img.style.transition = '';
      img.style.transform = '';
    }, dir ? 440 : 300);
  };
  if (typeof img.decode === 'function') img.decode().then(show, show);
  else if (img.complete) show();
  else img.onload = img.onerror = show;
}

// Round 74 (Vic: "when people are selecting the Top under, then it should show the GIF"): while the reduced top's line is
// open, the highlighted top's own clip (the product's first video, the one the cart's set module shows) plays behind
// the lines, muted, in a loop, its first frame as the poster until it plays (and if it may not play, Low Power Mode);
// a tap on another top swaps the clip. On any other line the look picture is back and the clip rests.
function setClip(src, poster) {
  const wrap = SET.el && SET.el.querySelector('[data-hb-set-bg]');
  if (!wrap) return;
  let v = wrap.querySelector('[data-hb-set-bgvid]');
  if (!src) {
    if (v) {
      v.classList.remove('is-on');
      try {
        v.pause();
      } catch (e) {}
    }
    SET.clip = '';
    return;
  }
  if (!v) {
    v = document.createElement('video');
    v.className = 'hb-sb__bgvid';
    v.setAttribute('data-hb-set-bgvid', '');
    v.setAttribute('aria-hidden', 'true');
    v.muted = true;
    v.loop = true;
    v.autoplay = true;
    v.playsInline = true;
    v.setAttribute('muted', '');
    v.setAttribute('playsinline', '');
    v.preload = 'auto';
    wrap.appendChild(v);
  }
  if (SET.clip !== src) {
    SET.clip = src;
    if (poster) v.poster = poster;
    v.src = src;
    v.load();
  }
  v.classList.add('is-on');
  const p = v.play();
  if (p && typeof p.catch === 'function') p.catch(() => {});
}

// a picture fetched ahead, once, so it is there when she gets to it
const WARM = new Set();
function warm(src) {
  if (!src || WARM.has(src) || src === SET.bg) return;
  WARM.add(src);
  const im = new Image();
  im.decoding = 'async';
  im.src = src;
}

// round 93 (Vic: "all swatch images should preload when possible ... silk set colors as first priority, then silk set
// colors with scarf, then scarf product images and then mini bag"): a queue in that order, two pictures on their way at
// a time, so the first ones arrive first; a picture already fetched (or the one behind everything) is skipped. Not on a
// connection that asks for less data.
const WARM_Q = [];
let warmBusy = 0;
function warmNext() {
  while (warmBusy < 2 && WARM_Q.length) {
    const src = WARM_Q.shift();
    if (!src || WARM.has(src) || src === SET.bg) continue;
    WARM.add(src);
    warmBusy++;
    const im = new Image();
    im.decoding = 'async';
    im.onload = im.onerror = () => {
      warmBusy--;
      warmNext();
    };
    im.src = src;
  }
}
function warmLater(list) {
  try {
    if (navigator.connection && navigator.connection.saveData) return;
  } catch (e) {
    /* nothing */
  }
  list.forEach((src) => {
    if (src && !WARM.has(src) && WARM_Q.indexOf(src) < 0) WARM_Q.push(src);
  });
  warmNext();
}

function preloadLooks() {
  if (!SET.data || !S.open || S.mode !== 'set') return;
  const d = SET.data;
  const list = [];
  // 1. her set in every colour (image 1)
  d.colors.forEach((c) => list.push(c.look || c.main.img));
  // 2. every colour with its scarf worn (image 2, shown from the scarf line on; round 63)
  d.colors.forEach((c) => list.push(c.look2));
  // 3. the scarves: their tiles, then the worn picture and the spotlight card
  (d.scarves || []).forEach((o) => list.push(o.thumb || o.img));
  (d.scarves || []).forEach((o) => list.push(o.look, o.img));
  // 4. the mini bags: their tiles, then the spotlight card; the pins' tiles last
  (d.bags || []).forEach((o) => list.push(o.thumb || o.img));
  (d.bags || []).forEach((o) => list.push(o.img));
  (d.pins || []).forEach((o) => list.push(o.thumb || o.img));
  warmLater(list);
}

// Round 54 (Vic, on round 50's mockups: "start with Option A for the scarf, i.e. change to set with the scarf worn. If
// choosing non-matching scarf where we of course don't have pictures, show scarf as option B spotlight card. And for mini
// bag show as option B spotlight card (and let the background picture be what stayed from Option A above)"). From the
// scarf line on (the bag and the set too), the picture is her set with her scarf worn when the scarf is her set's
// own color (the scarf's worn picture; her color's look when it has none, which shows the scarf since round 52); a scarf
// of another color has no such picture, so her color's look stays and the scarf shows in the spotlight card.
function scarfMatches(c, scarf) {
  const own = c ? scarfOfColour(c) : -1;
  return !!scarf && own >= 0 && SET.data.scarves[own] === scarf;
}
// Round 58 (Vic): "Step 1: For initial skirt & top color selection: always show a picture with Skirt + Top set without
// scarf (image 1). Step 2: When user reaches Scarf step, then picture changes automatically to image of same color Skirt +
// Top with matching scarf (image 2). Step 3: If user selects any scarf in non-matching color, then background goes back
// to showing image 1 + scarf image in their newly selected color next to it. For Mini Bag selection, the image from Step
// 3 stays." look: image 1, look2: image 2 (snippets/hb-set-json names them per colour)
// Round 63 (Vic: "When I have made selections, and then go BACK to Color of Skirt + Top, then when I change to a new
// color (and matching scarf auto-selects), then it should be showing Image 2"): the picture follows her set, not the
// line: once her scarf has come in (its line reached once, SET.scarfSeen), image 2 on every line when the scarf
// matches her colour (a new colour brings its own scarf, setColour), image 1 when it does not; before that, image 1.
function setPicture(c, scarf, key) {
  const late = key === 'scarf' || key === 'bag' || key === 'pins' || key === 'summary' || SET.scarfSeen;
  if (late && scarfMatches(c, scarf)) return c.look2 || scarf.look || c.look || c.main.img;
  return c.look || c.main.img;
}

// Round 52's five backgrounds behind the scarf and bag pictures (?hb_set_tile) are gone in round 53: Vic picked Smoke,
// "a little less dark", now the tiles' own (assets/hb-sheet.css)

// the spotlight card (round 50's mockup B; round 54: the bag always, the scarf when it is not her set's color): the chosen
// piece large in a smoked card, drawn bare: its line already says the name and the price (round 55)
function spotHtml(o, title, kind, bare) {
  return (
    '<div class="hb-sb__spot hb-sb__spot--' + kind + '"><span class="hb-sb__spotpic">' + pic(o && o.img, '', 'hb-sb__spotimg') + '</span>' +
    (bare ? '' : '<span class="hb-sb__spottx"><span class="hb-sb__nm">' + esc(title) + '</span>' + giftPrice(o) + '</span>') + '</div>'
  );
}

function onSetClick(e) {
  const t = e.target instanceof Element ? e.target : null;
  if (!t || SET.busy) return;
  // the first page: the pill starts the journey (the first line); the link opens and closes the receipt in place
  if (t.closest('[data-hb-set-start]')) {
    startSet();
    if (e.detail === 0) refocus('[data-hb-set-color].is-on');
    return;
  }
  if (t.closest('[data-hb-set-receipt]')) {
    SET.receipt = !SET.receipt;
    paintSet();
    if (e.detail === 0) refocus('[data-hb-set-receipt]');
    return;
  }
  // round 64 (Vic: "Make a click on first page also count as pressing BUILD MY SET and starting the flow"): a tap
  // anywhere on the first page starts, but on What is in the set and its open lines
  if (SET.intro) {
    if (!t.closest('.hb-sb__lns')) startSet();
    return;
  }
  // round 64: the length's row in the colour line (once the length is chosen) opens and closes Short and Regular
  if (t.closest('[data-hb-len-toggle]')) {
    SET.lenOpen = !SET.lenOpen;
    paintSet();
    return;
  }
  // a tap on a line's head opens that line (the one open folds away); a line after the open one confirms the
  // open one first, as its pill would (round 57, Vic: "tap on the next line indicates that they want to confirm")
  const line = t.closest('[data-hb-ac-go]');
  if (line) {
    let k = line.dataset.hbAcGo;
    if (k === SET.ac) return;
    const lines = acLines(setSteps());
    if (SET.ac && lines.indexOf(k) > lines.indexOf(SET.ac) && setCanAdvance()) SET.acDone[SET.ac] = true;
    // round 76 (Vic: "It should always require that Scarf is selected before Mini Bag"): a tap on a line beyond the
    // first one still to choose opens that first one instead, so the lines come in their order and none is passed over
    const first = lines.find((x) => !SET.acDone[x]);
    if (first && lines.indexOf(k) > lines.indexOf(first)) k = first;
    // round 84 (Vic: "If a selection is made, then clicking on any next step ... is treated as clicking the Button"):
    // on desktop the quiet lines still to come take the click too (assets/hb-sheet.css); with nothing to confirm yet
    // (her size sold out) the open line simply stays
    if (k === SET.ac) return;
    openLine(k);
    return;
  }
  const colour = t.closest('[data-hb-set-color]');
  if (colour) {
    const i = Number(colour.dataset.hbSetColor);
    if (!setColour(i, i > SET.color ? 1 : -1)) paintSet();
    return;
  }
  const len = t.closest('[data-hb-set-len]');
  if (len && !len.disabled) {
    SET.mk = String(len.dataset.hbSetLen);
    paintSet();
    // round 64: chosen in the colour line's row, the row folds back once she has seen her pick
    if (SET.lenOpen && SET.ac === 'color')
      setTimeout(() => {
        if (SET.el && SET.lenOpen && SET.ac === 'color') {
          SET.lenOpen = false;
          paintSet();
        }
      }, 320);
    return;
  }
  // round 71: a size on one of the main piece's axes (the swimsuit's size, the bikini's top or bottom)
  const size = t.closest('[data-hb-set-size]');
  if (size && !size.disabled) {
    const p = setPick();
    const axes = p.c.main.axes || [];
    const ai = Number(size.dataset.hbSetAxis) || 0;
    const parts = axes.length > 1 ? String(SET.mk).split('/') : [SET.mk];
    while (parts.length < axes.length) parts.push('');
    parts[ai] = String(size.dataset.hbSetSize);
    let k = parts.join('/');
    // a bikini pair that is out in this mix: the other row moves to the nearest in stock with her new size
    if (axes.length > 1 && !(mainVar(p.c, k) && mainVar(p.c, k).avail)) {
      const vars = p.c.main.vars.filter((x) => x.avail && x.k.split('/')[ai] === parts[ai]);
      const oi = ai === 0 ? 1 : 0;
      const vals = axes[oi].values;
      const ci = vals.indexOf(parts[oi]);
      const near = vals.map((v, j) => ({ v, d: Math.abs(j - ci) })).sort((a, b) => a.d - b.d).map((x) => x.v);
      const other = near.find((v) => vars.some((x) => x.k.split('/')[oi] === v));
      const want = parts.slice();
      want[oi] = other;
      if (vars.some((x) => x.k === want.join('/'))) k = want.join('/');
      else if (vars[0]) k = vars[0].k;
    }
    SET.mk = k;
    paintSet();
    return;
  }
  // round 71: the reduced top's colour and size
  const addon = t.closest('[data-hb-set-addon]');
  if (addon) {
    SET.addon = Number(addon.dataset.hbSetAddon);
    const a = SET.data.addons[SET.addon];
    if (!addonVar(a, SET.ak) || !addonVar(a, SET.ak).avail) SET.ak = defaultAddonSize(a);
    paintSet();
    return;
  }
  const asize = t.closest('[data-hb-set-asize]');
  if (asize && !asize.disabled) {
    SET.ak = String(asize.dataset.hbSetAsize);
    paintSet();
    return;
  }
  // round 71: the second piece with a line of its own (the Knit Belted Top)
  const second = t.closest('[data-hb-set-second]');
  if (second && second.disabled) return; // round 89: out
  if (second) {
    SET.second = Number(second.dataset.hbSetSecond);
    paintSet();
    return;
  }
  const scarf = t.closest('[data-hb-set-scarf]');
  if (scarf && scarf.disabled) return; // round 89: out
  if (scarf) {
    SET.scarf = Number(scarf.dataset.hbSetScarf);
    paintSet();
    return;
  }
  const bag = t.closest('[data-hb-set-bag]');
  if (bag && bag.disabled) return; // round 90: sold out
  if (bag) {
    SET.bag = Number(bag.dataset.hbSetBag);
    paintSet();
    return;
  }
  // round 71: the pins, pick two: a tap adds one (the same pin twice is two of it); with two chosen, a tap on another
  // lets the first one go; a tap on a chosen pin takes one away
  const pin = t.closest('[data-hb-set-pin]');
  if (pin) {
    const i = Number(pin.dataset.hbSetPin);
    const n = Number(SET.data.pinsPick) || 2;
    const at = SET.pins.indexOf(i);
    if (at >= 0 && SET.pins.length >= n && pin.dataset.hbSetPinOn === '1') SET.pins.splice(at, 1);
    else {
      if (SET.pins.length >= n) SET.pins.shift();
      SET.pins.push(i);
    }
    paintSet();
    return;
  }
  if (t.closest('[data-hb-set-cta]')) {
    // the open line is chosen and the next one opens (setAdvance); on the last page, the checkout
    if (acAll()) commitSet(true);
    else setAdvance();
    return;
  }
  if (t.closest('[data-hb-set-keep]')) {
    commitSet(false);
    return;
  }
  // a tap outside the lines and the pill (the picture) chooses the open line and folds it (round 58)
  if (SET.ac && !SET.intro && !t.closest('[data-hb-set-panel], [data-hb-set-foot], button, a')) foldLine();
}

// Round 58 (Vic: "If user goes back to step 1 and changes their Skirt + Top color, then their selection for Length + Mini
// Bag should not change, but Scarf should change to match"): her length or size is kept when the new colour has it in
// stock, the scarf follows the colour (round 71: the Bandeau Top and the Knit Belted Top too, when her pick was the old
// colour's own), the bag and the pins stay; dir: the side the new picture comes in from
function setColour(i, dir) {
  const d = SET.data;
  if (!d || i < 0 || i >= d.colors.length || i === SET.color) return false;
  const old = d.colors[SET.color];
  const c = d.colors[i];
  SET.color = i;
  const same = mainVar(c, SET.mk);
  if (!same || !same.avail) SET.mk = defaultMain(c);
  SET.scarf = matchScarf(c);
  if (d.addons.length) {
    const oldOwn = ofColour(d.addons, old);
    const own = ofColour(d.addons, c);
    if (own >= 0 && (SET.addon === oldOwn || oldOwn < 0)) {
      SET.addon = own;
      const a = d.addons[own];
      const keep = addonVar(a, SET.ak);
      if (!keep || !keep.avail) SET.ak = defaultAddonSize(a);
    }
  }
  if (!d.lock2 && d.seconds.length) {
    const oldOwn = ofColour(d.seconds, old);
    const own = ofColour(d.seconds, c);
    if (own >= 0 && (SET.second === oldOwn || oldOwn < 0)) SET.second = own;
  }
  SET.slide = dir || 0;
  paintSet();
  SET.slide = 0;
  return true;
}

function pic(src, alt, cls) {
  return src ? '<img class="' + cls + '" src="' + esc(src) + '" alt="' + esc(alt || '') + '" loading="lazy">' : '';
}

// a keyboard user keeps her place after a repaint
function refocus(sel) {
  const t = SET.el && SET.el.querySelector(sel);
  if (!t) return;
  try {
    t.focus({ preventScroll: true });
  } catch (err) {
    /* nothing */
  }
}

// the white pill's inside: the words trimmed to their capitals and the small chevron (the band's, round 47)
const CHEV = '<svg class="hb-sb__chev" width="5" height="8" viewBox="0 0 5 8" fill="none" aria-hidden="true"><path d="M1 1l3 3-3 3" stroke="currentColor" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"/></svg>';
const pillIn = (words) => '<span class="hb-sb__pbt">' + words + '</span>' + CHEV;
// the GIFT tag after a gift's name (round 48, Vic: "a bit clearer"): a small outlined capital tag
const GIFT_TAG = '<em class="hb-sb__tag">Gift</em>';

// Short first, then Regular, as everywhere else on the site (Vic, round 48); the indices stay the skirt's own
function lenOrder(c) {
  const rank = (n) => (/short/i.test(n) ? 0 : /regular/i.test(n) ? 1 : 2);
  return c.main.vars.map((l, i) => i).sort((a, b) => rank(c.main.vars[a].name) - rank(c.main.vars[b].name) || a - b);
}

// the swatch dots (the colours) and the picture tiles (the scarves, the bags, the tops, the pins: the piece itself, round 48)
function dotsHtml(attr, list, on) {
  return list
    .map(
      (o, i) =>
        '<span class="hb-sb__dotwrap"><button type="button" class="hb-sb__dot' + (i === on ? ' is-on' : '') + '" ' + attr + '="' + i + '" aria-label="' + esc(o.name) +
        '" aria-pressed="' + (i === on ? 'true' : 'false') + '">' + pic(o.swatch, '', 'hb-sb__dotimg') + '</button><span class="hb-sb__dotname">' + esc(o.name) + '</span></span>'
    )
    .join('');
}
// on: the chosen index, or a list of chosen indices (the pins, each with a count badge)
function tilesHtml(attr, list, on, cls) {
  const many = Array.isArray(on);
  return (
    '<div class="hb-sb__tiles' + (cls ? ' ' + cls : '') + '">' +
    list
      .map((o, i) => {
        const n = many ? on.filter((x) => x === i).length : i === on ? 1 : 0;
        // round 89: a piece she cannot add one more of (the last ones in her cart); round 90: or sold out; crossed out,
        // as a sold-out length is (Vic: "please just cross out"), and not to be chosen
        const out = !many && !!o.out;
        return (
          '<span class="hb-sb__tilewrap' + (out ? ' is-out' : '') + '"><button type="button" class="hb-sb__tile' + (n && !out ? ' is-on' : '') + (out ? ' is-out' : '') + '" ' + attr + '="' + i + '"' + (many ? ' data-hb-set-pin-on="' + (n ? 1 : 0) + '"' : '') +
          (out ? ' disabled' : '') +
          ' aria-label="' + esc(o.name) + (n > 1 ? ', ' + n : '') + (out ? ', sold out' : '') + '" aria-pressed="' + (n && !out ? 'true' : 'false') + '">' + pic(o.thumb || o.img || o.swatch, '', 'hb-sb__tileimg') +
          (many && n ? '<span class="hb-sb__tilen">' + (n > 1 ? '×' + n : '✓') + '</span>' : '') +
          '</button><span class="hb-sb__dotname">' + esc(o.name) + '</span></span>'
        );
      })
      .join('') +
    '</div>'
  );
}
// The length (the line since round 51, Vic: "Make this very simple"): Short and Regular side by side, the height under each
const LEN_CAP = { short: 'Below 165 cm (5′5″)', regular: 'Above 165 cm (5′5″)' };
// Round 66 (Vic: "On the button for SHORT and REGULAR could you please write "SHORT / 103cm" and "REGULAR / 110cm". This is
// good info for the user to see"): the skirt's length on its button, "cm" kept small (the button sets its words in capitals)
const LEN_CM = { short: '103cm', regular: '110cm' };
function lenChoice(c) {
  return (
    '<div class="hb-sb__lens" role="group" aria-label="Length">' +
    lenOrder(c)
      .map((i) => {
        const l = c.main.vars[i];
        const on = l.k === SET.mk;
        const cap = /short/i.test(l.name) ? LEN_CAP.short : /regular/i.test(l.name) ? LEN_CAP.regular : '';
        const cm = /short/i.test(l.name) ? LEN_CM.short : /regular/i.test(l.name) ? LEN_CM.regular : '';
        return (
          '<span class="hb-sb__len"><button type="button" class="hb-sb__pill' + (on ? ' is-on' : '') + (l.avail ? '' : ' is-out') + '" data-hb-set-len="' + esc(l.k) + '"' +
          (l.avail ? '' : ' disabled aria-label="' + esc(l.name) + ', sold out"') + ' aria-pressed="' + (on ? 'true' : 'false') + '"><span>' + esc(l.name) + (cm ? '<span class="hb-sb__lenbar" aria-hidden="true"></span><span class="hb-sb__lencm">' + esc(cm) + '</span>' : '') + '</span></button>' +
          (cap ? '<span class="hb-sb__lencap">' + esc(cap) + '</span>' : '') +
          (!l.avail ? '<span class="hb-sb__lencap">Sold out</span>' : l.pre ? '<span class="hb-sb__lencap">Preorder</span>' : '') +
          '</span>'
        );
      })
      .join('') +
    '</div>'
  );
}
// round 71: the sizes of the main piece, one row of pills per axis (the swimsuit's Size; the bikini's Top and Bottom, each
// row named), the quick add's pills; a size with no piece in stock is struck
function sizeChoice(c) {
  const axes = c.main.axes || [];
  const vars = c.main.vars;
  const parts = axes.length > 1 ? String(SET.mk).split('/') : [SET.mk];
  // a size is offered while any piece with it is in stock (a bikini top in M with some bottom; the other row then
  // follows, onSetClick), so a row never strikes a size she can still have
  const avail = (ai, v) => (axes.length === 1 ? vars.some((x) => x.k === v && x.avail) : vars.some((x) => x.k.split('/')[ai] === v && x.avail));
  const pre = (ai, v) => {
    const k = axes.length === 1 ? v : parts.map((p, j) => (j === ai ? v : p)).join('/');
    const x = vars.find((y) => y.k === k);
    return !!(x && x.pre);
  };
  return axes
    .map(
      (ax, ai) =>
        '<div class="hb-sb__sizes" role="group" aria-label="' + esc(ax.name) + '">' +
        (axes.length > 1 ? '<span class="hb-sb__axis">' + esc(ax.name) + '</span>' : '') +
        '<span class="hb-sb__pills">' +
        ax.values
          .map((v) => {
            const on = parts[ai] === v;
            const ok = avail(ai, v);
            return (
              '<button type="button" class="hb-sb__pill' + (on ? ' is-on' : '') + (ok ? '' : ' is-out') + '" data-hb-set-size="' + esc(v) + '" data-hb-set-axis="' + ai + '"' +
              (ok ? '' : ' disabled aria-label="' + esc(v) + ', sold out"') + ' aria-pressed="' + (on ? 'true' : 'false') + '"><span>' + esc(v) + '</span></button>'
            );
          })
          .join('') +
        '</span>' +
        (parts[ai] && pre(ai, parts[ai]) ? '<span class="hb-sb__lencap">Preorder</span>' : '') +
        '</div>'
    )
    .join('');
}
// round 71: the reduced top's sizes
function addonSizes(a) {
  if (!a || !a.sizes.length) return '';
  return (
    '<div class="hb-sb__sizes" role="group" aria-label="Size"><span class="hb-sb__pills">' +
    a.sizes
      .map((v) => {
        const on = v.name === SET.ak;
        return (
          '<button type="button" class="hb-sb__pill' + (on ? ' is-on' : '') + (v.avail ? '' : ' is-out') + '" data-hb-set-asize="' + esc(v.name) + '"' +
          (v.avail ? '' : ' disabled aria-label="' + esc(v.name) + ', sold out"') + ' aria-pressed="' + (on ? 'true' : 'false') + '"><span>' + esc(v.name) + '</span></button>'
        );
      })
      .join('') +
    '</span></div>'
  );
}
// the gift's own price struck out, and Complimentary clear under it (Vic, round 48)
function giftPrice(o) {
  return '<span class="hb-sb__gift">' + (o ? '<s>' + SET.fmt(o.cents) + '</s>' : '') + '<span class="hb-sb__comp">Complimentary</span></span>';
}

// what comes with the set, in one line (the first page's second line, the band's; round 69: the simple words)
// round 71: per set: the gifts counted (the scarf, the bag, the pins), the reduced top named
function giftsLine(steps, p) {
  const d = SET.data;
  const gifts = (steps.indexOf('scarf') >= 0 && p.scarf ? 1 : 0) + (steps.indexOf('bag') >= 0 && p.bag ? 1 : 0);
  const pins = steps.indexOf('pins') >= 0 && d.pins.length;
  const addon = steps.indexOf('addon') >= 0 && d.addon ? d.addon : null;
  if (addon) {
    const top = 'With the ' + addon.label + ' at ' + addon.pct + '% off';
    return gifts ? top + ' and a gift from us.' : top + '.';
  }
  if (pins) return 'With ' + (Number(d.pinsPick) || 2) + ' complimentary pins.';
  if (gifts === 2) return 'With 2 gifts from us.';
  if (gifts === 1) return 'With a gift from us.';
  if (d.kind === 'pair') return d.pieces + ', in your color.';
  if (d.seconds.length) return d.pieces + ' and ' + d.fam2 + ', in your color.';
  return 'In your color, with your size.';
}

// the same for the strip at the top of the lines (round 45), where there is room for a few words only: the gifts
// counted (the reduced top counts as one, as the cart calls it "a gift from us", round 37; the two pins as two)
function stripLine(steps, p) {
  const d = SET.data;
  let gifts = (steps.indexOf('scarf') >= 0 && p.scarf ? 1 : 0) + (steps.indexOf('bag') >= 0 && p.bag ? 1 : 0);
  if (steps.indexOf('addon') >= 0 && d.addon) gifts += 1;
  if (steps.indexOf('pins') >= 0 && d.pins.length) gifts += Number(d.pinsPick) || 2;
  if (gifts >= 2) return 'With ' + gifts + ' gifts from us.';
  if (gifts === 1) return 'With a gift from us.';
  return 'In your color.';
}

// The first page (Vic's pick B6, without the steps row): the figures from setPick(), never written in
function firstPage(steps, p) {
  const fmt = SET.fmt;
  const d = SET.data;
  const { scarf, bag, pins, second, addonItem, addonSize, total } = p;
  const hasScarf = steps.indexOf('scarf') >= 0 && !!scarf;
  const hasBag = steps.indexOf('bag') >= 0 && !!bag;
  const hasPins = steps.indexOf('pins') >= 0 && d.pins.length > 0;
  const hasAddon = steps.indexOf('addon') >= 0 && !!addonItem && !!addonSize;
  const n = (hasScarf ? 1 : 0) + (hasBag ? 1 : 0) + (hasPins ? 1 : 0) + (hasAddon ? 1 : 0) + (steps.indexOf('second') >= 0 ? 1 : 0);
  const head = giftsLine(steps, p);
  const ln = (l, r, cls) => '<div class="hb-sb__ln' + (cls ? ' ' + cls : '') + '"><span>' + l + '</span><span>' + r + '</span></div>';
  const open = SET.receipt && n;
  let lines = '';
  if (open) {
    // the GIFT tag where Complimentary was (Vic, round 58: "remove Complimentary completely")
    lines += ln(esc(d.pieces), fmt(p.main ? p.main.cents + (d.lock2 && second ? second.cents : 0) : 0));
    if (steps.indexOf('second') >= 0 && second) lines += ln(esc(d.fam2 || second.title), fmt(second.cents));
    if (hasAddon) lines += ln(esc(d.addon.label), '<s>' + fmt(p.addonFull) + '</s>' + fmt(p.addonNow));
    if (hasScarf) lines += ln('Silk Tulle Scarf', '<s>' + fmt(scarf.cents) + '</s>' + GIFT_TAG);
    if (hasBag) lines += ln('Mini Bag', '<s>' + fmt(bag.cents) + '</s>' + GIFT_TAG);
    if (hasPins) lines += ln((Number(d.pinsPick) || 2) + ' pins', (pins.length ? '<s>' + fmt(pins.reduce((s, x) => s + x.cents, 0)) + '</s>' : '') + GIFT_TAG);
  }
  // round 68 (Vic: "On first page ... Also remove "Your set with 2 gifts""): no total line on the first page (round 51's
  // "Your set with 2 gifts" and its prices); "What is in the set" still opens the pieces with their prices
  const cta = esc(SET.el.dataset.cta || 'Build my set');
  void total;
  return (
    '<span class="hb-sb__cap">' + esc(d.cap) + '</span>' +
    '<span class="hb-sb__fh">' + esc(head) + '</span>' +
    // round 68 (Vic: "On first page, remove "Silk Tulle Skirt and Top, with the Silk Tulle Scarf and the Mini Bag""): the
    // light line is gone (the pieces are in "What is in the set")
    '<div class="hb-sb__lns' + (open ? ' is-open' : '') + '">' + lines + '</div>' +
    '<div class="hb-sb__go"><button type="button" class="hb-sb__pb" data-hb-set-start>' + pillIn(cta) + '</button>' +
    (n
      ? '<button type="button" class="hb-sb__lk" data-hb-set-receipt aria-expanded="' + (SET.receipt ? 'true' : 'false') + '">' +
        (SET.receipt ? 'Hide' : 'What’s in the set') + '</button>'
      : '') +
    '</div>'
  );
}

// ---------------------------------------------------------------------------------------------------------------
// The lines (HB 2026-10-14, round 48, Vic: "the person has stayed on same smooth page the whole way through"): the set's
// lines, the summary's own, fold open one at a time over the picture: her main piece's colour, its length or sizes
// (round 51, two lines where there was one), then the pieces that come with it. The open line shows its choices; the
// pill below chooses it, the line folds with a small swatch of her pick on it and the next one opens. No steps row.
// Round 68 (Vic: "Option 2 feedback (this is our choice, focus on this only now) ... Make the previous dark option Option 3
// now and keep this as comparison piece that we will have to decide against"): Option 2 is the builder (the band, live);
// Option 3 is the same builder in round 66's dark (the second band on all-apparel, data-hb-set-v="3", or ?hb_set_v=3).
// Round 71: Option 1 (the steps, ?hb_set_v=1) is gone.

// HB 2026-10-23 (Vic: "Remove all the 'Option 3' etc, and keep only our main one we have worked on and tested
// throughout"): the builder is Option 2, always; ?hb_set_v and a choice kept for the visit no longer open Option 3, and the
// band that asked for it is gone (snippets/hb-set-band)
function setVariant() {
  try {
    sessionStorage.removeItem('hb_set_v');
  } catch (e) {
    /* nothing kept */
  }
  return 2;
}
// the option the opening band asks for, else the visit's: 3 is Option 2 in the dark
const setWant = () => S.wantV || setVariant();
const setVn = () => (SET.dark ? 3 : 2);

// Round 51 (Vic: "This should be separated to a 2-step process: Color first, then Length"): one line per step, the
// colour, the length (when her colour has more than one), the scarf, the bag; round 71: the lines the set has (setSteps)
// Round 64 (Vic: "After Length has been selected the first time, then don't continue to show it as a line, but fold
// it into the Color swatch line when this is open, written at the bottom similar to it is now and pressing around
// Length or Short/Regular will unfold it as it was before selection"): once the length is chosen, its line folds away
// and the colour line, open, carries a Length row at its foot (Length, her length); a tap on it opens Short and Regular
// in place. The lines she moves through skip it from then on.
function lenFolded(steps) {
  // Round 82 (Vic, 21 Oct: "due to more space, Length may not need to fold down into color after its selection, but can
  // stay out as its own line"): on desktop the length keeps its line; the phone folds it as before
  if (!phone()) return false;
  return steps.indexOf('length') >= 0 && !!SET.acDone.length && SET.ac !== 'length';
}
// Round 82 (Vic, 22 Oct: "For all lines, keep it "Product Title, (Color)" and then the swatch"): a piece reads as its
// family, then her colour ("Silk Tulle Scarf, White", "Mini Bag, Ocean Blue"), as the set's own line does; on desktop
// first, round 83 on the phone too (Vic: "Should the phone switch ... so both match?" "yes.")
const deskName = (fam, o) => (o && o.name ? fam + ', ' + o.name : fam);
function acLines(steps) {
  return lenFolded(steps) ? steps.filter((k) => k !== 'length') : steps.slice();
}
function lenSub(c, len, chev) {
  const on = !!SET.lenShown;
  return (
    '<div class="hb-ac__sub' + (on ? ' is-open' : '') + '" data-ac-sub><button type="button" class="hb-ac__hd hb-ac__subhd" data-hb-len-toggle aria-expanded="' +
    (on ? 'true' : 'false') + '"><span class="hb-ac__t">Length' + chev + '</span><span class="hb-ac__r">' + esc(len ? len.name : '') + '</span></button>' +
    '<div class="hb-ac__bd"><div class="hb-ac__in"><div class="hb-ac__pad">' + lenChoice(c) + '</div></div></div></div>'
  );
}
// Option 2: every line chosen (the last page: the total, the checkout). A tap outside a line reopened from there folds
// it back to this page, Continue to checkout (round 59, Vic: "if all are selected it remains on the CONTINUE TO
// CHECKOUT")
function acAll() {
  return !SET.ac && acLines(setSteps()).every((k) => SET.acDone[k]);
}
// Round 58 (Vic: "if I have selected PINK on the color and then click "outside" the field, this should also make it a
// selection and fold the color selector down without automatically opening Length"): the open line is chosen and folds.
// Round 65 (Vic: "IF no length selected, and someone selects Skirt & Top color, but then click on page to "select" and
// close the color selector, then it should automatically progress to their next choice - i.e. length. Only if length,
// scarf and mini bag are already selected should it just fold down and close the line. If any choices are missing, we
// always need to guide the user through each step until they are done"): a tap outside is the pill: the open line is
// chosen and the next missing one opens; with nothing missing the line folds and the last page shows
function foldLine() {
  if (!SET.ac || !setCanAdvance()) return;
  setAdvance();
  track('hb_sheet_step', { flow: 'set', v: setVn(), step: 'fold' });
}

// Round 65 (Vic: "FREE SHIPPING. ALL DUTIES & TAXES INCLUDED." ... "make sure this message follows other logic on
// website and only shows for non-EU visitors; for EU visitors it should just be "FREE PRIORTY SHIPPING. 1-3 DAYS
// DELIVERY.""): the line under the Total follows the site's own rules. Duties only outside the EU (snippets/
// hb-non-eu-visitor, the cart's and the product page's test, sections/hb-set's "nonEu"); "Free" only once the
// complimentary-shipping amount is reached, as the cart and the product page say it (snippets/hb-ship-threshold, "ship");
// Denmark ships with PostNord in 1-2 days, as the product page says, so it is not called priority there
function shipNote(total) {
  const d = SET.data;
  const free = d.ship > 0 && total >= d.ship;
  if (d.nonEu) return (free ? 'Free shipping. ' : '') + 'All duties & taxes included.';
  if (String(d.cc || '').toUpperCase() === 'DK') return (free ? 'Free shipping. ' : '') + '1-2 days delivery.';
  return (free ? 'Free priority shipping. ' : 'Priority shipping. ') + '1-3 days delivery.';
}

function openLine(key) {
  SET.intro = false;
  SET.ac = key;
  SET.acRest = '';
  SET.lenOpen = false;
  SET.lenShown = false;
  paintSet();
  track('hb_sheet_step', { flow: 'set', v: setVn(), step: key || 'summary' });
}

// Round 63 (Vic: "After a slight bit of inactivity, maybe 5 seconds, can you make the 4 lines (Skirt + Top Color,
// Length, Scarf, Mini Bag) all collapse/hide by folding down into the line above Total, and then just leaving only space
// for the beautiful imagery and then the Total line and the Continue to Checkout. Perhaps when doing this, also remove a
// bit of the darkness from the image"): Option 2's last page on the phone rests after 4 s (round 75; 5 s before) without a touch. The four
// lines fold down into the Total's hairline, the lowest first (70 ms apart), the note under the Total and the keep link
// go with them, the words at the top fade, the darkening under the words shrinks and the one from the top softens; the
// Total and Continue to checkout stay. Any touch, click, wheel or key brings it all back at once and starts the 5 s again.
// Round 87 (Vic, 22 Oct: "please fix this so button of course matches what it should be"): the keep link under the
// pill fades where it is and keeps its room (assets/hb-sheet.css), so the pill never moves at rest; before, the link
// folded away and the pill sank 27 px onto the link's place, and since round 85 a tap there went to the checkout.
const CALM_MS = 4000; // round 75 (Vic: "Make the rest happen after -1s"): 5 s before
const calm = { timer: 0, on: false, items: [], veil: 0, v0: 0 };
function calmOk() {
  return !!(S.open && S.mode === 'set' && SET.el && SET.data && !SET.intro && !SET.busy && phone() && acAll());
}
function calmArm() {
  clearTimeout(calm.timer);
  // round 85: on its way to the checkout the page stays at rest (One moment on the pill)
  if (calm.on && SET.busy && SET.busyKind === 'checkout') return;
  if (!calmOk()) {
    if (calm.on) calmWake();
    return;
  }
  if (!calm.on) calm.timer = setTimeout(calmIn, CALM_MS);
}
function calmIn() {
  if (!calmOk() || calm.on) return;
  const el = SET.el;
  const still = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const lines = Array.from(el.querySelectorAll('[data-hb-ac] > .hb-ac__ln')).reverse();
  const rest = [q('[data-ac-k]', el), SET.foot && q('[data-hb-set-keep]', SET.foot)].filter((x) => x && !x.hidden);
  const items = lines.concat(rest);
  items.forEach((it, i) => {
    it.style.setProperty('--hb-h', it.offsetHeight + 'px');
    it.style.transitionDelay = still || i >= lines.length ? '0s' : (i * 0.07).toFixed(2) + 's';
    it.classList.add('hb-calm-it');
  });
  void el.offsetWidth;
  calm.items = items;
  calm.on = true;
  el.classList.add('is-calm');
  track('hb_sheet_calm', { v: setVn() });
  // round 68: the Mist from the Total's hairline down only; round 70: from the first moment (a forecast of where the
  // Total will sit once the lines under it have folded), corrected once they have
  calmVeil(true);
  calm.veil = setTimeout(() => calmVeil(false), 480);
}
// Round 68 (Vic: "On last page when everything is folded down, the opacity should only reach up to the line over "Total",
// but not beyond that - show the visitor the full piece and its actual color"): the folded page's Mist is its own short
// layer, from the Total's hairline to the foot (and a 10 px feather above), crossfaded in once the lines have folded
// Round 69 (Vic: "blur line on last page is now super ugly. Far too obvious"): one layer, no edge: the Mist's own eased
// run settles to the Total's hairline plus 24 px (from nothing there). Round 70 (Vic: "a bit of lag/delay"): from the
// first moment, by transform: its height held at what it is (--hb-veil0) and scaled down (--hb-veil-k). At the start the
// Total's place is forecast: the words under it that fold away (the shipping line, "keep browsing") each give back their
// height and 10 px (their gap less the rest's -10 px margin); once they have folded it is measured and the scale
// corrected. Option 3 keeps round 66's rest
function calmVeil(first) {
  if (!calm.on || !SET.el || SET.dark) return;
  const low = q('[data-hb-set-low]', SET.el);
  const tot = low && q('.hb-ac__total', low);
  if (!tot) return;
  if (first || !calm.v0) {
    calm.v0 = parseFloat(getComputedStyle(low, '::before').height) || low.offsetHeight;
    low.style.setProperty('--hb-veil0', Math.round(calm.v0) + 'px');
  }
  let h = low.getBoundingClientRect().bottom - tot.getBoundingClientRect().top;
  if (first) {
    calm.items.forEach((it) => {
      // round 87: the keep link keeps its room, so it gives nothing back
      if (low.contains(it) && !it.matches('[data-hb-set-keep]') && tot.compareDocumentPosition(it) & Node.DOCUMENT_POSITION_FOLLOWING) h -= it.offsetHeight + 10;
    });
  }
  low.style.setProperty('--hb-veil-k', Math.min(1, Math.max(0.05, (h + 24) / calm.v0)).toFixed(4));
  low.classList.add('is-veil');
}
function calmUnveil() {
  clearTimeout(calm.veil);
  calm.v0 = 0;
  const low = SET.el && q('[data-hb-set-low]', SET.el);
  if (low) low.classList.remove('is-veil', 'is-veil0');
}
function calmWake() {
  clearTimeout(calm.timer);
  calmUnveil();
  if (!calm.on) return;
  calm.on = false;
  const items = calm.items;
  calm.items = [];
  items.forEach((it) => {
    it.style.transitionDelay = '0s';
  });
  if (SET.el) SET.el.classList.remove('is-calm');
  // the measured heights rest until the lines are back, then go (a line opened later grows freely)
  setTimeout(() => {
    if (calm.on) return;
    items.forEach((it) => {
      it.classList.remove('hb-calm-it');
      it.style.removeProperty('--hb-h');
      it.style.transitionDelay = '';
    });
  }, 520);
}
function calmReset() {
  clearTimeout(calm.timer);
  calmUnveil();
  calm.on = false;
  calm.items = [];
}

// the words of a line's head (its title and right side) and its open body, per line kind (round 71: from the set)
function lineParts(k, p, isOpen, done, extras) {
  const d = SET.data;
  const fmt = SET.fmt;
  const { c, main, second, addonItem, addonSize, scarf, bag, pins } = p;
  const { mark, again, comp, folded } = extras;
  let t = '';
  let r = '';
  let body = '';
  if (k === 'color') {
    t = esc(setTitle(c)) + (done && !isOpen ? mark(c.swatch) : '');
    r = fmt(main ? main.cents + (d.lock2 && second ? second.cents : 0) : 0);
    if (isOpen) body = '<div class="hb-sb__dots">' + dotsHtml('data-hb-set-color', d.colors, SET.color) + '</div>' + (folded ? lenSub(c, main, again) : '');
  } else if (k === 'length') {
    t = 'Length';
    r = done && !isOpen && main ? esc(main.name) : '';
    // round 82 (Vic: "let "Regular" or "Short" be in a pill" ... "next to Length, similar to the Color swatches"):
    // on desktop her length sits in a small pill after the word, where a colour's swatch sits
    if (!phone()) {
      t = 'Length' + (done && !isOpen && main ? '<span class="hb-ac__val">' + esc(main.name) + '</span>' : '');
      r = '';
    }
    if (isOpen) body = lenChoice(c);
  } else if (k === 'size') {
    // round 71: the swimsuit's size, the bikini's top and bottom ("Top M · Bottom S")
    const axes = c.main.axes || [];
    t = axes.length > 1 ? 'Sizes' : 'Size';
    if ((done || isOpen) && main) {
      const parts = String(main.k).split('/');
      r = axes.length > 1 ? axes.map((ax, i) => esc(ax.name) + ' ' + esc(parts[i] || '')).join(' · ') : esc(main.name);
    }
    if (isOpen) body = sizeChoice(c);
  } else if (k === 'second') {
    // round 71: the Knit Belted Top with the bikini, its own colour (tiles), One Size
    t = (done || isOpen) && second ? esc(deskName(d.fam2 || 'The top', second)) + (done && !isOpen ? mark(second.swatch) : '') : esc(d.fam2 || 'The top');
    r = second ? fmt(second.cents) : '';
    if (isOpen) body = tilesHtml('data-hb-set-second', d.seconds, SET.second, 'hb-sb__tiles--bag') + (second && second.size ? '<span class="hb-sb__lt">' + esc(second.size) + '.</span>' : '');
  } else if (k === 'addon') {
    // round 71: the top at the reduced price, "50% off, a gift from us" as the cart says it (round 37)
    t = (done || isOpen) && addonItem ? esc(deskName(d.addon.label, addonItem)) + (done && !isOpen ? mark(addonItem.swatch) : '') : esc(d.addon.label);
    r = addonSize ? '<s>' + fmt(p.addonFull) + '</s>' + fmt(p.addonNow) : '';
    if (isOpen)
      body =
        tilesHtml('data-hb-set-addon', d.addons, SET.addon, 'hb-sb__tiles--bag') +
        addonSizes(addonItem) +
        '<span class="hb-sb__lt">' + esc(d.addon.pct + '% off, a gift from us.') + '</span>';
  } else if (k === 'scarf') {
    // the tiles alone, the line under them gone (Vic, round 51); round 55 (Vic: "Yes to the 3 you presented"): her
    // set's own scarf worn in the picture behind, another colour in the spotlight card, bare
    t = (done || isOpen) && scarf ? esc(deskName('Silk Tulle Scarf', scarf)) + (done && !isOpen ? mark(scarf.swatch) : '') : 'Silk Tulle Scarf';
    r = (scarf ? '<s>' + fmt(scarf.cents) + '</s>' : '') + comp;
    if (isOpen) body = tilesHtml('data-hb-set-scarf', d.scarves, SET.scarf, '');
  } else if (k === 'bag') {
    t = (done || isOpen) && bag ? esc(deskName('Mini Bag', bag)) + (done && !isOpen ? mark(bag.swatch) : '') : 'Mini Bag';
    r = (bag ? '<s>' + fmt(bag.cents) + '</s>' : '') + comp;
    if (isOpen) body = tilesHtml('data-hb-set-bag', d.bags, SET.bag, 'hb-sb__tiles--bag');
  } else if (k === 'pins') {
    // round 71: two complimentary pins with the Knit Belted Top (Gold, Silver, Swirl, Star), picked one by one
    const n = Number(d.pinsPick) || 2;
    const names = pinNames(pins);
    t = (done || isOpen) && pins.length ? esc(names) : n + ' pins';
    r = (pins.length ? '<s>' + fmt(pins.reduce((s, x) => s + x.cents, 0)) + '</s>' : '') + comp;
    if (isOpen)
      body =
        tilesHtml('data-hb-set-pin', d.pins, SET.pins, 'hb-sb__tiles--bag hb-sb__tiles--pins') +
        '<span class="hb-sb__lt">' + esc(pins.length >= n ? 'Your ' + n + ' pins. Tap one to change it.' : pins.length ? 'One more.' : 'Choose ' + n + ', the same one twice if you like.') + '</span>';
  }
  return { t, r, body };
}
// "Gold and Star Silver", "Gold, 2" (two of one)
function pinNames(pins) {
  const counts = [];
  pins.forEach((p) => {
    const hit = counts.find((x) => x.p === p);
    if (hit) hit.n += 1;
    else counts.push({ p, n: 1 });
  });
  return counts.map((x) => x.p.title + (x.n > 1 ? ' ×' + x.n : '')).join(' and ');
}

function paintLines(steps, p) {
  const el = SET.el;
  const fmt = SET.fmt;
  const { c, main, scarf, bag, pins, total, was } = p;
  const lines = acLines(steps);
  const rows = steps.slice(); // every line is drawn; a chosen length folds away in place (round 64)
  const folded = lenFolded(steps);
  const panel = q('[data-hb-set-panel]', el);
  // the lines are drawn once per opening, so a line folds and unfolds rather than being redrawn (drawn again only when
  // her colour brings or takes away the length line)
  const keys = rows.join(',');
  if (!panel.querySelector('[data-hb-ac]') || panel.dataset.acKeys !== keys) {
    panel.dataset.acKeys = keys;
    panel.innerHTML =
      '<div class="hb-ac__spot" data-ac-spot></div><div class="hb-ac" data-hb-ac>' +
      rows
        .map(
          (k) =>
            '<div class="hb-ac__ln" data-ac="' + k + '"><button type="button" class="hb-ac__hd" data-hb-ac-go="' + k + '"><span class="hb-ac__t"></span><span class="hb-ac__r"></span></button>' +
            '<div class="hb-ac__bd"><div class="hb-ac__in"><div class="hb-ac__pad"></div></div></div></div>'
        )
        .join('') +
      '<div class="hb-ac__gifts" data-ac-gifts aria-hidden="true"></div>' +
      '<div class="hb-sb__ln hb-sb__ln--total hb-ac__total" data-ac-total></div></div><span class="hb-sb__k" data-ac-k hidden></span>';
  }
  const all = acAll();
  const mark = (src) => (src ? '<img class="hb-ac__mark" src="' + esc(src) + '" alt="">' : '');
  // a chosen line opens again on a tap (round 55, Vic: "can user go back by pressing on each line?"): a small chevron says so
  const again = '<svg class="hb-ac__again" width="8" height="5" viewBox="0 0 8 5" fill="none" aria-hidden="true"><path d="M1 1l3 3 3-3" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  // the gifts' price struck and the GIFT tag where Complimentary was (Vic, round 58: "instead of Complimentary, use the
  // oblong GIFT pill from the first page")
  const comp = GIFT_TAG;
  rows.forEach((k) => {
    const ln = panel.querySelector('[data-ac="' + k + '"]');
    if (!ln) return;
    // round 64: the chosen length's line folds away (held at its height, then to nothing), into the colour line
    if (k === 'length') {
      if (folded && !ln.classList.contains('is-folded')) {
        ln.style.setProperty('--hb-h', ln.offsetHeight + 'px');
        ln.classList.add('is-folding');
        void ln.offsetWidth;
        ln.classList.add('is-folded');
      } else if (!folded) ln.classList.remove('is-folded', 'is-folding');
    }
    const isOpen = SET.ac === k;
    const done = !!SET.acDone[k];
    // round 69 (Vic: "... then the Length selector folds up from Total line"): a line reached for the first time
    // unfolds just above the Total (CSS .hb-ac__ln.is-ahead), clipped while it grows
    const wasAhead = ln.classList.contains('is-ahead');
    ln.classList.toggle('is-open', isOpen);
    ln.classList.toggle('is-done', done && !isOpen);
    ln.classList.toggle('is-ahead', !done && !isOpen);
    if (wasAhead && !ln.classList.contains('is-ahead')) {
      ln.classList.add('is-revealing');
      clearTimeout(ln.hbReveal);
      ln.hbReveal = setTimeout(() => ln.classList.remove('is-revealing'), 620);
    }
    const hd = ln.querySelector('.hb-ac__hd');
    hd.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    const { t, r, body } = lineParts(k, p, isOpen, done, { mark, again, comp, folded });
    ln.querySelector('.hb-ac__t').innerHTML = t + (done && !isOpen ? again : '');
    ln.querySelector('.hb-ac__r').innerHTML = r;
    // a folding line keeps its content until it has folded, so it closes smoothly
    if (isOpen) ln.querySelector('.hb-ac__pad').innerHTML = body;
    // round 65 (Vic: "when that line is opened again the height of the Length section does not match the lines below"):
    // the Length row ends the colour line as a line ends (the line's own foot space goes)
    if (isOpen) ln.querySelector('.hb-ac__pad').classList.toggle('hb-ac__pad--sub', k === 'color' && folded);
  });
  // round 64: the colour line's Length row opens and closes in place (drawn as it was, then moved, so it folds)
  const sub = panel.querySelector('[data-ac-sub]');
  if (!sub) SET.lenShown = false;
  else if (!!SET.lenShown !== !!SET.lenOpen)
    requestAnimationFrame(() => {
      if (!sub.isConnected) return;
      void sub.offsetWidth;
      sub.classList.toggle('is-open', !!SET.lenOpen);
      const b = sub.querySelector('[data-hb-len-toggle]');
      if (b) b.setAttribute('aria-expanded', SET.lenOpen ? 'true' : 'false');
      SET.lenShown = !!SET.lenOpen;
    });
  // round 64 (Vic: "At the final 5s rest ... can you leave 2 small smoky background images of the selected scarf and the
  // selected bag in bottom left corner over total line?"): her gifts, small on smoked glass above the Total, shown only
  // while the last page rests (assets/hb-sheet.css, .is-calm); round 71: the pins too
  const giftsEl = panel.querySelector('[data-ac-gifts]');
  if (giftsEl) {
    const gl = [];
    if (scarf && steps.indexOf('scarf') >= 0) gl.push(['scarf', scarf]);
    if (bag && steps.indexOf('bag') >= 0) gl.push(['bag', bag]);
    if (steps.indexOf('pins') >= 0) pins.forEach((x) => gl.push(['pin', x]));
    const gk = gl.map(([kind, o]) => kind + ':' + (o.thumb || o.img || '')).join('|');
    if (giftsEl.dataset.k !== gk) {
      giftsEl.dataset.k = gk;
      // round 65 (Vic: "a tiny bit bigger and also be same height ... add a small pills saying "GIFTS" over them"):
      // the GIFTS tag (the GIFT tag's own style) over them, left
      giftsEl.innerHTML = gl.length
        ? '<em class="hb-sb__tag hb-ac__giftstag">Your gifts</em><span class="hb-ac__giftrow">' +
          gl.map(([kind, o]) => '<span class="hb-ac__gift hb-ac__gift--' + kind + '"><img class="hb-ac__giftimg" src="' + esc(o.thumb || o.img || '') + '" alt="" decoding="async"></span>').join('') +
          '</span>'
        : '';
    }
  }
  // Round 56 (Vic: "Option 2 Scarf and Bag are bad. The larger image should show above the top line"): the card of
  // another colour's scarf, and of the bag, sits above the first line, bare (the open line says its name and price);
  // round 71: the reduced top and the second piece the same way
  const spot = panel.querySelector('[data-ac-spot]');
  const spotNow =
    SET.ac === 'scarf' && scarf && !scarfMatches(c, scarf)
      ? spotHtml(scarf, '', 'scarf', true)
      : SET.ac === 'bag' && bag
        ? spotHtml(bag, '', 'bag', true)
        : SET.ac === 'addon' && p.addonItem && !p.addonItem.clip
          ? spotHtml(p.addonItem, '', 'bag', true)
          : SET.ac === 'second' && p.second && !SET.data.lock2
            ? spotHtml(p.second, '', 'bag', true)
            : '';
  if (spot.innerHTML !== spotNow) spot.innerHTML = spotNow;
  panel.querySelector('[data-ac-total]').innerHTML =
    '<span>Total' + (was > total ? '<span class="hb-sb__sv">You save ' + fmt(was - total) + '</span>' : '') + '</span><span>' + (was > total ? '<s>' + fmt(was) + '</s>' : '') + fmt(total) + '</span>';
  const kEl = panel.querySelector('[data-ac-k]');
  kEl.textContent = shipNote(total);
  // round 84 (Vic: "Move 'Free shipping. 1-2 days delivery.' ... under the button centered. And let it stay from the
  // beginning till end"): on desktop the note shows on every step, under the pill (assets/hb-sheet.css)
  if (all) SET.seenEnd = true;
  // round 85 (Vic, the phone: "Once 'FREE SHIPPING. 1-2 DAYS DELIVERY' shows, then don't make it disappear all the
  // time. It can only disappear on the rest page"): on the phone too it stays once the last page has shown it
  kEl.hidden = !all && !SET.seenEnd && phone();

  // the pill: it chooses the open line; with every line chosen it goes to the checkout
  const foot = SET.foot;
  const cta = q('[data-hb-set-cta]', foot);
  const keep = q('[data-hb-set-keep]', foot);
  const price = q('[data-hb-set-price]', foot);
  if (cta) {
    const nextKey = lines.find((x) => !SET.acDone[x]);
    const words = {
      length: ['Continue to length', 'Choose this length'],
      size: ['Continue to your size', 'Choose this size'],
      second: ['Continue to your ' + (SET.data.fam2 || 'top'), 'Choose this ' + (SET.data.fam2 || 'top')],
      addon: ['Continue to your ' + (SET.data.addon ? SET.data.addon.label : 'top'), 'Choose this ' + (SET.data.addon ? SET.data.addon.label : 'top')],
      scarf: ['Continue to your Silk Tulle Scarf', 'Choose this Silk Tulle Scarf'],
      bag: ['Continue to your Mini Bag', 'Choose this Mini Bag'],
      pins: ['Continue to your pins', pins.length >= (Number(SET.data.pinsPick) || 2) ? 'Choose these pins' : 'Choose your pins'],
      color: ['Continue', 'Choose this color'],
    };
    let tx;
    if (all) tx = 'Continue to checkout · ' + fmt(total);
    else if (!SET.ac) tx = (words[nextKey] || words.color)[0];
    else tx = (words[SET.ac] || words.color)[1];
    cta.className = 'hb-sb__cta hb-sb__pb hb-sb__pb--wide';
    cta.innerHTML = SET.busy && SET.busyKind !== 'keep' ? pillIn('One moment') : pillIn(tx);
    const pinsOk = SET.ac !== 'pins' || pins.length >= (Number(SET.data.pinsPick) || 2);
    const addonOk = !p.addonItem || !!(p.addonSize && p.addonSize.avail);
    cta.disabled = SET.busy || !p.mainOk || !pinsOk || !addonOk || !main;
  }
  if (price) {
    price.innerHTML = '';
    price.hidden = true;
  }
  if (keep) {
    // round 84 (Vic: "let them stay like that no matter what is clicked, so they do not keep changing"): on desktop the
    // keep link, once the last page has shown it, stays when she opens a line again; it waits while her pick is sold out
    keep.hidden = !(all || (!phone() && SET.seenEnd));
    keepLabel(keep);
    if (!p.mainOk || !main) keep.disabled = true;
  }
}

// every repaint ends by (re)starting the last page's 5 s rest (round 63, calmArm)
function paintSet() {
  paintSetNow();
  calmArm();
}
function paintSetNow() {
  const el = SET.el;
  if (!el || !SET.data) return;
  const steps = setSteps();
  const p = setPick();
  const { c, scarf } = p;
  const intro = !!SET.intro;

  // The picture behind everything: the look of her colour (round 47); the first page or the lines over it. From the
  // scarf line on, her set with her scarf worn when it is her set's colour (round 54, setPicture); its picture is fetched
  // ahead on the colour and length lines
  const keyNow = intro ? 'color' : SET.ac || SET.acRest || 'summary';
  if (keyNow === 'color' || keyNow === 'length' || keyNow === 'size') warm(c.look2);
  if (!intro && keyNow !== 'color' && keyNow !== 'length' && keyNow !== 'size' && !SET.scarfSeen && steps.indexOf('scarf') >= 0) {
    SET.scarfSeen = true;
    setTimeout(preloadLooks, 400);
  }
  el.classList.toggle('is-first', intro);
  // the first page: the band's picture (round 63); the lines: her set's (setPicture)
  setBg(intro && SET.introSrc ? SET.introSrc : setPicture(c, scarf, keyNow));
  // round 74: the top's clip while its line is open (swimsuit sets)
  const clipItem = !intro && keyNow === 'addon' && p.addonItem && p.addonItem.clip ? p.addonItem : null;
  setClip(clipItem ? clipItem.clip : '', clipItem ? clipItem.poster : '');
  el.classList.add('is-v2');
  const first = q('[data-hb-set-first]', el);
  q('[data-hb-set-top]', el).hidden = intro;
  q('[data-hb-set-low]', el).hidden = intro;
  first.hidden = !intro;

  // The head: Back from the colour line on (to the first page from there); round 63 (Vic: "Remove < Back button"): not
  // on the phone, where a swipe down or a tap on a line goes back
  // round 82: on desktop not on the colour line either, the first there is (no first page)
  // round 92: on the phone on every page, the first page included (there it closes the builder)
  setHead(phone() ? { back: 'Back' } : intro || SET.ac === 'color' ? {} : { back: 'Back' });
  if (intro) {
    first.innerHTML = firstPage(steps, p);
    return;
  }
  first.innerHTML = '';
  // the words at the top (round 45: "Your Silk Tulle Set", "With 2 gifts from us"); round 71: the set's own
  const cap = q('[data-hb-set-cap]', el);
  const sub = q('[data-hb-set-sub]', el);
  if (cap) cap.textContent = SET.data.cap || '';
  if (sub) {
    sub.textContent = stripLine(steps, p);
    // round 74: a long headline ("Your Bandeau Silk Swimsuit") leaves no room for the count on a phone: the headline alone then
    sub.hidden = false;
    if (sub.clientWidth > 0 && sub.scrollWidth > sub.clientWidth + 1) sub.hidden = true;
  }
  paintLines(steps, p);
}

// Round 55 (Vic: "When click 'Add to cart and continue shopping', it looked like the 'Continue to checkout' button
// registered a click"): the link she tapped says One moment, the checkout pill keeps its words (and waits, disabled)
const KEEP_WORDS = 'Add to cart and keep browsing';
// round 93: where the Back from a checkout reached from the builder lands (the cart open over Signature Styles)
const CHECKOUT_BACK_URL = '/collections/signature-styles?cart=open';
function keepLabel(keep) {
  keep.textContent = SET.busy && SET.busyKind === 'keep' ? 'One moment' : KEEP_WORDS;
  keep.disabled = SET.busy;
}

async function commitSet(checkout) {
  if (SET.busy || !SET.data) return;
  const d = SET.data;
  const p = setPick();
  const { c, main, second, addonItem, addonSize, scarf, bag, pins, total } = p;
  if (!c || !main || !p.mainOk) return;
  SET.busy = true;
  SET.busyKind = checkout ? 'checkout' : 'keep';
  paintSet();
  // the set's key on every line the builder adds (the cart's set module reads _hb_set)
  const props = { _hb_set: d.key };
  const items = [{ id: Number(main.id), quantity: 1, properties: props }];
  if (second) items.push({ id: Number(second.id), quantity: 1, properties: props });
  // round 71: the top at the reduced price goes in as it is; the gift discount Function reduces it by the pair
  if (addonItem && addonSize) items.push({ id: Number(addonSize.id), quantity: 1, properties: props });
  // The scarf is marked for the discount that will make it complimentary (_hb_gift = set-scarf); not with _free_gift,
  // which the cart reads as the one gift of the order and would keep the mini bag out (snippets/hb-tgift-calc)
  if (scarf) items.push({ id: Number(scarf.id), quantity: 1, properties: { _hb_set: d.key, _hb_gift: 'set-scarf' } });
  // round 71: the pins as the pins module adds them (assets/hb-pins.js: one line per pin, _hb_gift = pins, the Function
  // makes two per Knit Belted Top complimentary); the same pin twice is one line of two
  if (pins.length) {
    const byId = new Map();
    pins.forEach((x) => byId.set(Number(x.id), (byId.get(Number(x.id)) || 0) + 1));
    byId.forEach((qty, id) => items.push({ id, quantity: qty, properties: { _hb_gift: 'pins' } }));
  }
  const post = (path, body) =>
    fetch(path, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body),
    }).then(async (r) => {
      if (!r.ok) {
        // round 86: the cart's own answer travels with the error (its status and words), for the message below
        const err = new Error(path + ' ' + r.status);
        err.status = r.status;
        err.body = await r.json().catch(() => null);
        throw err;
      }
      return r.json();
    });
  try {
    // Her mini bag, reserved exactly as RESERVE MY GIFT does (assets/hb-tgift.js reads the attribute and adds the bag at the amount)
    if (bag) await post('/cart/update.js', { attributes: { hb_gift_reserved: bag.handle } });
    // The scarf goes in as it is, marked for the discount that will make it complimentary (Vic, 14 Oct: "Make the scarf
    // add correctly for now, even though we do not have the working discount built yet")
    // round 85: on desktop the add brings the cart's own markup (and the gift's state) along, so the cart opens with
    // her set in it at once
    const addBody = { items };
    const cartSid = !checkout && !phone() ? cartSection() : '';
    if (cartSid) {
      addBody.sections = window.HBGift ? cartSid + ',hb-tgift-state' : cartSid;
      addBody.sections_url = location.pathname;
    }
    const data = await post('/cart/add.js', addBody);
    try {
      if (typeof window.triggerKlaviyoAddedToCart === 'function') window.triggerKlaviyoAddedToCart(data);
    } catch (e) {
      /* nothing */
    }
    track('hb_sheet_add', {
      mode: 'set',
      set: d.key,
      color: c.name,
      size: main.k,
      second: second ? second.title : '',
      addon: addonItem ? addonItem.title + ' ' + (addonSize ? addonSize.name : '') : '',
      scarf: scarf ? scarf.name : '',
      bag: bag ? bag.handle : '',
      pins: pins.map((x) => x.handle).join(','),
      total,
    });
    if (checkout) {
      track('hb_sheet_checkout', { flow: 'set', set: d.key });
      // The bag goes in through the gift's own script; the checkout waits for it (a few seconds at most)
      await bagInCart(bag);
      // round 93 (Vic: back from the checkout "she should land on open cart with signature styles collection behind
      // it"): this page's entry in the history becomes that address, so the Back from the checkout loads it; a page
      // the browser keeps and brings back as it was goes there itself (pageshow, init)
      try {
        history.replaceState({ hbSheetCheckout: 1 }, '', CHECKOUT_BACK_URL);
      } catch (e) {
        /* the Back then shows the collection she came from */
      }
      location.href = '/checkout';
      return;
    }
    // Round 85 (Vic, desktop: "When click 'Add to cart', should open cart with items in it"): the builder closes and the
    // cart opens (its auto-open) with her pieces; the reserved bag then floats in as the gift does in an open cart
    // (assets/hb-tgift.js reads its state from the same event)
    if (!phone()) {
      close();
      setTimeout(() => openCartWith(data, cartSid), SHEET_MS + 20);
      return;
    }
    // Keep browsing on the phone: the quick add's own note rises with the set's name and picture; the cart stays closed
    try {
      if (window.HBCart && window.HBCart.state) {
        window.HBCart.state.qaPiece = { name: c.name + ' ' + (d.setName || 'set'), img: c.main.img || '', at: performance.now() };
      }
    } catch (e) {
      /* the note then shows without the piece */
    }
    close();
    setTimeout(() => {
      document.dispatchEvent(new CartUpdateEvent({ source: 'variant-popup-inner' }));
      try {
        if (window.HBGift && typeof window.HBGift.refresh === 'function') window.HBGift.refresh();
      } catch (e) {
        /* nothing */
      }
    }, SHEET_MS + 20);
  } catch (e) {
    // round 86 (Vic: the message should state "(Product) is sold out."): a piece the cart cannot take is named; any
    // other refusal keeps the old words
    let gone = '';
    try {
      gone = await soldOutName(e, p);
    } catch (e2) {
      gone = '';
    }
    SET.busy = false;
    paintSet();
    // the message on the button she tapped
    const btn = q(checkout ? '[data-hb-set-cta]' : '[data-hb-set-keep]', SET.foot);
    if (btn) {
      btn.textContent = gone ? gone + ' is sold out.' : 'Not added, try again';
      // the pill takes two lines when the words need them (assets/hb-sheet.css .is-msg; the next paint drops the class)
      if (btn.classList.contains('hb-sb__pb')) btn.classList.add('is-msg');
      setTimeout(() => paintSet(), gone ? 4000 : 2500);
    }
  }
}

// Round 86: which of her pieces the cart refused (a 422): the piece its words name; else the one her cart already holds
// the last of ("max", what was left when the page opened, snippets/hb-set-json); else one the store has sold out since
// (its product's own .js). The name is the product's, with the length or size when it has more than one.
async function soldOutName(err, p) {
  if (!err || err.status !== 422 || !p) return '';
  const named = (title, vname) => (vname && !/^(one size|default title)$/i.test(vname) ? title + ' in ' + vname : title);
  const tried = [];
  if (p.c && p.main) tried.push({ v: p.main, name: named(p.c.main.title, p.main.name), title: p.c.main.title, url: p.c.main.url });
  if (p.second) tried.push({ v: p.second, name: p.second.title, title: p.second.title, url: p.second.url || (p.second.handle ? '/products/' + p.second.handle : '') });
  if (p.addonItem && p.addonSize) tried.push({ v: p.addonSize, name: named(p.addonItem.title, p.addonSize.name), title: p.addonItem.title, url: '/products/' + p.addonItem.handle });
  if (p.scarf) tried.push({ v: p.scarf, name: p.scarf.title, title: p.scarf.title, url: '/products/' + p.scarf.handle });
  (p.pins || []).forEach((x) => tried.push({ v: x, name: x.title || x.name, title: x.title || '', url: x.handle ? '/products/' + x.handle : '' }));
  const words = String((err.body && (err.body.description || err.body.message)) || '');
  const said = tried.find((x) => x.title && words.indexOf(x.title) !== -1);
  if (said) return said.name;
  try {
    const cart = await fetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } }).then((r) => r.json());
    const held = (id) => (cart.items || []).filter((i) => Number(i.variant_id) === Number(id)).reduce((s, i) => s + i.quantity, 0);
    const want = (id) => tried.filter((x) => Number(x.v.id) === Number(id)).length;
    const last = tried.find((x) => typeof x.v.max === 'number' && held(x.v.id) + want(x.v.id) > x.v.max);
    if (last) return last.name;
  } catch (e) {
    /* the product check below */
  }
  for (const x of tried) {
    if (!x.url) continue;
    try {
      const pr = await fetch(x.url.split('?')[0] + '.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } }).then((r) => r.json());
      const v = (pr.variants || []).find((y) => Number(y.id) === Number(x.v.id));
      if (v && v.available === false) return x.name;
    } catch (e) {
      /* the next piece */
    }
  }
  return '';
}

// Round 85: the cart drawer's section (assets/hb-cart.js asks for the same one), and the cart opened with what the add
// brought back; without the markup the drawer fetches its own
function cartSection() {
  const el = document.querySelector('cart-drawer-component cart-items-component');
  return (el && el.dataset.sectionId) || '';
}
function openCartWith(data, sid) {
  const sections = data && data.sections;
  let itemCount;
  try {
    const html = sections && sid && sections[sid];
    const n = html ? new DOMParser().parseFromString(html, 'text/html').querySelector('[ref="cartItemCount"]') : null;
    if (n) itemCount = parseInt(n.textContent, 10) || 0;
  } catch (e) {
    itemCount = undefined;
  }
  const detail = { source: 'hb-set' };
  if (sections) detail.sections = sections;
  if (typeof itemCount === 'number') detail.itemCount = itemCount;
  document.dispatchEvent(new CartUpdateEvent({}, 'hb-set', detail));
  const root = document.querySelector('cart-drawer-component');
  const box = root && root.querySelector('dialog');
  if (root && typeof root.open === 'function' && !(box && box.open)) root.open();
  try {
    if (!(sections && sections['hb-tgift-state']) && window.HBGift && typeof window.HBGift.refresh === 'function') window.HBGift.refresh();
  } catch (e) {
    /* nothing */
  }
}

// The gift's script puts the reserved bag in once the cart is over the amount; wait for it (at most 5 s)
async function bagInCart(bag) {
  const g = window.HBGift;
  if (!bag || !g) return;
  try {
    if (typeof g.refresh === 'function') g.refresh();
  } catch (e) {
    /* nothing */
  }
  const until = performance.now() + 5000;
  while (performance.now() < until) {
    try {
      const st = g.state && g.state.cur;
      if (st && st.bagKey) return;
      if (st && st.on === false) return;
    } catch (e) {
      return;
    }
    await new Promise((r) => setTimeout(r, 150));
  }
}

// ---------------------------------------------------------------------------------------------------------------
// The silk story reel (sections/hb-story)

function openStory(opener) {
  if (!open('story', opener)) return;
  const d = dlg();
  d.setAttribute('aria-label', 'The silk behind it');
  d.classList.add('is-story'); // a narrower window on desktop: one card and the next peeking
  setHead({});
  q('[data-hb-sl-body]', d).innerHTML = '<div class="hb-sl__wait hb-sl__wait--set"><div class="hb-sl__wait-name">One moment.</div></div>';
  q('[data-hb-sl-foot]', d).innerHTML = '';
  loadStory();
}

async function loadStory() {
  const my = ++S.req;
  let html = S.storyHtml;
  if (!html) {
    try {
      const res = await fetch('/?section_id=hb-story', { credentials: 'same-origin' });
      if (!res.ok) throw new Error('hb-story ' + res.status);
      html = await res.text();
      S.storyHtml = html;
    } catch (e) {
      html = '';
    }
  }
  if (my !== S.req || !S.open) return;
  const doc = new DOMParser().parseFromString(html, 'text/html');
  const el = doc.querySelector('[data-hb-story]');
  if (!el) {
    q('[data-hb-sl-body]').innerHTML = '<div class="hb-sl__wait hb-sl__wait--set"><div class="hb-sl__wait-name">The story is not available right now.</div></div>';
    return;
  }
  mountStory(el);
}

function mountStory(el) {
  const d = dlg();
  const body = q('[data-hb-sl-body]', d);
  const foot = q('[data-hb-sl-foot]', d);
  body.innerHTML = '';
  foot.innerHTML = '';
  foot.hidden = false;
  if (S.leaveFit) {
    q('[data-hb-sl-back]', d).removeEventListener('click', S.leaveFit);
    S.leaveFit = null;
  }
  body.appendChild(el);
  body.scrollTop = 0;
  STORY.el = el;
  STORY.n = Number(el.dataset.count) || el.querySelectorAll('[data-hb-story-card]').length;
  STORY.ms = (Number(el.dataset.seconds) || 5) * 1000;
  STORY.i = 0;
  STORY.held = false;
  STORY.swallow = false;
  // The first two pictures now, the rest as they come near
  el.querySelectorAll('[data-hb-story-card]').forEach((c, i) => {
    const img = c.querySelector('img');
    if (img && i < 2) img.loading = 'eager';
  });
  const rail = el.querySelector('[data-hb-story-rail]');
  el.querySelector('[data-hb-story-next]').addEventListener('click', () => {
    if (STORY.swallow) return;
    storyGo(STORY.i + 1, 'tap');
  });
  el.querySelector('[data-hb-story-back]').addEventListener('click', () => {
    if (STORY.swallow) return;
    storyGo(STORY.i - 1, 'tap');
  });
  // A hold pauses the timer (and the picture stays); a swipe turns the page
  rail.addEventListener('pointerdown', (e) => {
    if (e.target instanceof Element && e.target.closest('[data-hb-story-set]')) return;
    STORY.down = { x: e.clientX, y: e.clientY, t: performance.now() };
    STORY.swallow = false;
    try {
      rail.setPointerCapture(e.pointerId); // the up arrives here wherever the finger ends
    } catch (err) {
      /* nothing */
    }
    clearTimeout(STORY.holdTimer);
    STORY.holdTimer = setTimeout(() => {
      STORY.held = true;
      pauseStory();
    }, 220);
  });
  const swallow = () => {
    STORY.swallow = true;
    setTimeout(() => {
      STORY.swallow = false;
    }, 80);
  };
  const up = (e) => {
    clearTimeout(STORY.holdTimer);
    const dn = STORY.down;
    STORY.down = null;
    if (STORY.held) {
      STORY.held = false;
      resumeStory();
      swallow();
      return;
    }
    if (!dn || !e || typeof e.clientX !== 'number') return;
    const dx = e.clientX - dn.x;
    const dy = e.clientY - dn.y;
    if (Math.abs(dx) > 48 && Math.abs(dx) > Math.abs(dy)) {
      swallow();
      storyGo(STORY.i + (dx < 0 ? 1 : -1), 'swipe');
      return;
    }
    if (Math.abs(dx) < 10 && Math.abs(dy) < 10) {
      // a tap: the right 60% turns the page, the left 40% turns back (the two buttons' own clicks serve the keyboard)
      const r = rail.getBoundingClientRect();
      swallow();
      storyGo(STORY.i + ((e.clientX - r.left) / r.width < 0.4 ? -1 : 1), 'tap');
    }
  };
  rail.addEventListener('pointerup', up);
  rail.addEventListener('pointercancel', () => up(null));
  // A long press is the hold, never the phone's own menu (HB 2026-10-14, round 45)
  rail.addEventListener('contextmenu', (e) => {
    e.preventDefault();
  });
  // The set: the builder takes the sheet over
  el.querySelectorAll('[data-hb-story-set]').forEach((b) => {
    b.addEventListener('click', (e) => {
      e.preventDefault();
      switchToSet();
    });
  });
  window.addEventListener('resize', placeStory);
  paintStory();
  startStory();
  track('hb_sheet_story', { card: 1 });
}

function storyGo(n, how) {
  if (!STORY.el) return;
  const to = Math.max(0, Math.min(STORY.n - 1, n));
  if (to === STORY.i) return;
  STORY.i = to;
  paintStory();
  startStory();
  track('hb_sheet_story', { card: to + 1, how: how || 'timer' });
}

function placeStory() {
  const el = STORY.el;
  if (!el) return;
  const track = el.querySelector('[data-hb-story-track]');
  const card = el.querySelector('[data-hb-story-card]');
  if (!track || !card) return;
  const gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap) || 8;
  const rail = el.querySelector('[data-hb-story-rail]');
  let x = -STORY.i * (card.offsetWidth + gap);
  if (STORY.i === STORY.n - 1 && STORY.n > 1 && rail) {
    // The last card ends flush right, the one before it peeking on the left: she sees she can go back (Vic, 14 Oct)
    const padLeft = parseFloat(getComputedStyle(rail).paddingLeft) || 0;
    x = rail.clientWidth - card.offsetWidth - padLeft - STORY.i * (card.offsetWidth + gap);
  }
  track.style.transform = 'translateX(' + x + 'px)';
}

function paintStory() {
  const el = STORY.el;
  if (!el) return;
  const i = STORY.i;
  el.querySelectorAll('[data-hb-story-card]').forEach((c, k) => {
    c.classList.toggle('is-cur', k === i);
    const img = c.querySelector('img');
    if (img && k <= i + 1) img.loading = 'eager';
  });
  placeStory();
  const counter = el.querySelector('[data-hb-story-counter]');
  if (counter) counter.textContent = i + 1 + ' of ' + STORY.n;
  // The segments: the ones before full, the current one fills over the timer, the rest empty
  el.querySelectorAll('[data-hb-story-seg]').forEach((seg, k) => {
    const b = seg.querySelector('b');
    if (!b) return;
    b.style.transition = 'none';
    if (k < i) b.style.width = '100%';
    else if (k > i) b.style.width = '0%';
    else b.style.width = i === STORY.n - 1 ? '100%' : '0%';
  });
}

function startStory() {
  clearTimeout(STORY.timer);
  STORY.timer = 0;
  const last = STORY.i >= STORY.n - 1;
  STORY.left = STORY.ms;
  if (last || !STORY.el) return;
  runStory(STORY.ms);
}

function runStory(ms) {
  const el = STORY.el;
  if (!el) return;
  const b = el.querySelector('[data-hb-story-seg="' + (STORY.i + 1) + '"] b');
  if (b) {
    // the fill continues from where it stands (the width it has now)
    const w = b.getBoundingClientRect().width;
    const full = b.parentElement.getBoundingClientRect().width || 1;
    b.style.transition = 'none';
    b.style.width = (w / full) * 100 + '%';
    void b.offsetWidth;
    b.style.transition = 'width ' + ms + 'ms linear';
    b.style.width = '100%';
  }
  STORY.startedAt = performance.now();
  STORY.left = ms;
  STORY.timer = setTimeout(() => {
    STORY.timer = 0;
    storyGo(STORY.i + 1, 'timer');
  }, ms);
}

function pauseStory() {
  if (!STORY.timer) return;
  clearTimeout(STORY.timer);
  STORY.timer = 0;
  STORY.left = Math.max(0, STORY.left - (performance.now() - STORY.startedAt));
  const b = STORY.el && STORY.el.querySelector('[data-hb-story-seg="' + (STORY.i + 1) + '"] b');
  if (b) {
    const w = b.getBoundingClientRect().width;
    const full = b.parentElement.getBoundingClientRect().width || 1;
    b.style.transition = 'none';
    b.style.width = (w / full) * 100 + '%';
  }
}

function resumeStory() {
  if (STORY.timer || !STORY.el || STORY.i >= STORY.n - 1) return;
  runStory(Math.max(300, STORY.left));
}

function stopStory() {
  clearTimeout(STORY.timer);
  clearTimeout(STORY.holdTimer);
  STORY.timer = 0;
  STORY.el = null;
  STORY.held = false;
  STORY.down = null;
  window.removeEventListener('resize', placeStory);
}

// BUILD MY SET inside the reel: the builder takes the open sheet (no close, no second history entry)
function switchToSet() {
  if (!S.open || S.mode !== 'story') return;
  stopStory();
  S.mode = 'set';
  const d = dlg();
  d.classList.remove('is-story');
  d.classList.add('is-set');
  d.classList.toggle('is-dark', setWant() === 3); // round 68: the reel of Option 3's band opens Option 3
  d.setAttribute('aria-label', 'The Silk Tulle Set');
  setHead({});
  q('[data-hb-sl-body]', d).innerHTML = '<div class="hb-sl__wait hb-sl__wait--set"><div class="hb-sl__wait-name">One moment.</div></div>';
  q('[data-hb-sl-foot]', d).innerHTML = '';
  track('hb_sheet_story_set', {});
  S.wantKey = DEFAULT_SET; // the reel is the Silk Tulle Set's own
  loadSet({ start: true });
}

// ---------------------------------------------------------------------------------------------------------------
// The opener on the cards, and the ways out

// (the card tap that opens the quick view is in assets/hb-qv.js since QV round 1)

let swipe = null;
function onHeadDown(e) {
  if (!phone()) return;
  if (e.target instanceof Element && e.target.closest('button')) return; // the x and Back are taps, never the start of a swipe
  swipe = { y: e.clientY, t: performance.now() };
  try {
    // the head keeps the pointer, so the up arrives here wherever the finger ends (touch does this on its own; a mouse does not)
    e.currentTarget.setPointerCapture(e.pointerId);
  } catch (err) {
    /* nothing */
  }
}
// (round 58: the sheet follows the finger frame by frame through dragTo, the lag Vic felt was its easing behind the
// finger and the glass redrawn on every frame)
function onHeadMove(e) {
  if (!swipe) return;
  const dy = e.clientY - swipe.y;
  if (dy > 0) dragTo(dy);
}
function onHeadUp(e) {
  if (!swipe) return;
  const dy = e.clientY - swipe.y;
  const dt = performance.now() - swipe.t;
  swipe = null;
  dragEnd(dy > 70 || (dy > 30 && dt < 250));
}

function init() {
  const d = dlg();
  if (!d || d.dataset.hbSlReady) return;
  d.dataset.hbSlReady = '1';
  window.HBSheet = { version: VERSION, open, close, setHead, SHEET_MS, openSet, openStory, blocked, state: S, set: SET, story: STORY };
  // The sets: "Build my set" on a band (snippets/hb-set-band, its set's key read by openSet); the story: its tile and the band's link
  document.addEventListener('click', (e) => {
    const t = e.target instanceof Element ? e.target.closest('[data-hb-set-open], [data-hb-story-open]') : null;
    if (!t || t.closest('dialog.hb-sl')) return;
    e.preventDefault();
    if (S.open || blocked()) return;
    // the band that asks for Option 2 opens it (round 49), its reel's BUILD MY SET too
    const want = t.closest('[data-hb-set-v]');
    S.wantV = want ? Number(want.getAttribute('data-hb-set-v')) || 0 : 0;
    if (t.hasAttribute('data-hb-story-open')) openStory(t);
    else {
      // HB 2026-11-02: a colour on the band (snippets/hb-set-band, data-hb-set-colour) opens the builder on that colour
      const colour = t.getAttribute('data-hb-set-colour');
      openSet(t, null, colour ? { color: colour, start: true } : undefined);
    }
  });
  // The Option 2 band is for comparing on the unpublished theme: never on the live one
  try {
    if (window.Shopify && window.Shopify.theme && window.Shopify.theme.role === 'main') {
      document.querySelectorAll('.hb-band[data-hb-set-v]').forEach((b) => b.remove());
    }
  } catch (e) {
    /* nothing */
  }
  // ?hb_set=open and ?hb_story=open: a link straight to the builder or the reel; round 71: ?hb_set=<key> opens that set
  try {
    const want = new URLSearchParams(location.search);
    const setWantKey = want.get('hb_set') || '';
    let which = setWantKey ? 'set' : want.get('hb_story') === 'open' ? 'story' : '';
    // HB 2026-10-16 (the launch copy, no set builders): a link opens only what is switched on, as snippets/hb-sheet
    // says on the dialog (data-sets, data-story), so ?hb_set=open with the set off opens nothing, never an empty sheet;
    // without those attributes (an older snippet) it behaves as before
    const slEl = document.querySelector('[data-hb-sl]');
    const setsAttr = slEl ? slEl.getAttribute('data-sets') : null;
    if (which === 'set' && setsAttr !== null && !setsAttr.split(',').includes(setWantKey === 'open' ? DEFAULT_SET : setWantKey)) which = '';
    if (which === 'story' && slEl && slEl.getAttribute('data-story') === '0') which = '';
    if (which) {
      setTimeout(() => {
        if (S.open || blocked()) return;
        S.wantV = 0;
        if (which === 'set') openSet(null, setWantKey === 'open' ? DEFAULT_SET : setWantKey);
        else openStory(null);
      }, 600);
    }
  } catch (e) {
    /* nothing */
  }
  // round 63: the builder's section fetched ahead once a band is near the screen (prefetchSet)
  try {
    const bands = document.querySelectorAll('.hb-band[data-hb-band="set"]');
    if (bands.length && 'IntersectionObserver' in window) {
      const io = new IntersectionObserver(
        (entries) => {
          if (!entries.some((en) => en.isIntersecting)) return;
          io.disconnect();
          prefetchSet();
        },
        { rootMargin: '800px 0px' }
      );
      bands.forEach((b) => io.observe(b));
    }
  } catch (e) {
    /* nothing */
  }
  // The reel rests while the tab is hidden
  document.addEventListener('visibilitychange', () => {
    if (!STORY.el) return;
    if (document.hidden) pauseStory();
    else resumeStory();
  });
  q('[data-hb-sl-close]', d).addEventListener('click', () => close());
  d.addEventListener('click', (e) => {
    // The dim: the dialog itself outside the panel
    if (e.target === d) close();
  });
  d.addEventListener('cancel', (e) => {
    // Esc: close our way, so the history entry goes with it
    e.preventDefault();
    close();
  });
  window.addEventListener('popstate', () => {
    // HB 2026-10-15 (QV round 2, fix 5.151): a layer inside the sheet may take the Back first: S.onBack() closes it
    // and answers true, and the sheet stays (the quick view's Size guide & info, assets/hb-qv.js)
    if (S.open && typeof S.onBack === 'function' && S.onBack()) return;
    if (S.open) close(true);
    // (the quick view's "Take me to the product" goes on from here in assets/hb-qv.js, its own popstate listener)
  });
  // round 93: the browser brought this page back as it was when she left it for the checkout from the builder (the
  // pill still saying One moment): the builder is hidden at once and the page goes to the cart over Signature Styles
  window.addEventListener('pageshow', (e) => {
    if (!e.persisted || !SET.busy || SET.busyKind !== 'checkout') return;
    try {
      d.removeAttribute('open');
      d.style.display = 'none';
    } catch (err) {
      /* nothing */
    }
    location.replace(CHECKOUT_BACK_URL);
  });
  const head = q('[data-hb-sl-head]', d);
  head.addEventListener('pointerdown', onHeadDown);
  head.addEventListener('pointermove', onHeadMove);
  head.addEventListener('pointerup', onHeadUp);
  head.addEventListener('pointercancel', () => {
    swipe = null;
    dragEnd(false);
  });
  // A swipe down on the content when it is scrolled to its top
  const body = q('[data-hb-sl-body]', d);
  let touch = null;
  // (the set builder has its own, round 57: only a pull from above its words closes it, setGestures)
  body.addEventListener('touchstart', (e) => {
    touch = S.mode !== 'set' && body.scrollTop <= 0 && e.touches.length === 1 ? { y: e.touches[0].clientY, t: performance.now() } : null;
  }, { passive: true });
  body.addEventListener('touchend', (e) => {
    if (!touch) return;
    const dy = (e.changedTouches[0] ? e.changedTouches[0].clientY : touch.y) - touch.y;
    const dt = performance.now() - touch.t;
    touch = null;
    if (body.scrollTop <= 0 && dy > 90 && dt < 400) close();
  }, { passive: true });
}

if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
else init();
